import * as e from "react";
import t, { createContext as n, useContext as r, useRef as o, useEffect as i, useLayoutEffect as a, useCallback as s, useMemo as u, forwardRef as c, createElement as l, useState as f, useDebugValue as d } from "react";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var _p = function p() {
  return _p = Object.assign || function (e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    return e;
  }, _p.apply(this, arguments);
};
function v(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var o = 0;
    for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  }
  return n;
}
function m(e, t) {
  var n = "function" == typeof Symbol && e[Symbol.iterator];
  if (!n) return e;
  var r,
    o,
    i = n.call(e),
    a = [];
  try {
    for (; (void 0 === t || t-- > 0) && !(r = i.next()).done;) a.push(r.value);
  } catch (e) {
    o = {
      error: e
    };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}
function h(e, t, n) {
  if (n || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
  return e.concat(r || Array.prototype.slice.call(t));
}
function y(e, t) {
  return Object.defineProperty ? Object.defineProperty(e, "raw", {
    value: t
  }) : e.raw = t, e;
}
var g = function g(e) {
    return {
      isEnabled: function isEnabled(t) {
        return e.some(function (e) {
          return !!t[e];
        });
      }
    };
  },
  b = {
    measureLayout: g(["layout", "layoutId", "drag", "_layoutResetTransform"]),
    animation: g(["animate", "exit", "variants", "whileHover", "whileTap", "whileFocus", "whileDrag"]),
    exit: g(["exit"]),
    drag: g(["drag", "dragControls"]),
    focus: g(["whileFocus"]),
    hover: g(["whileHover", "onHoverStart", "onHoverEnd"]),
    tap: g(["whileTap", "onTap", "onTapStart", "onTapCancel"]),
    pan: g(["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"]),
    layoutAnimation: g(["layout", "layoutId"])
  };
function w(e) {
  for (var t in e) {
    var n = e[t];
    null !== n && (b[t].Component = n);
  }
}
var x = function x() {},
  S = function S() {};
"production" !== process.env.NODE_ENV && (x = function x(e, t) {
  e || "undefined" == typeof console || console.warn(t);
}, S = function S(e, t) {
  if (!e) throw new Error(t);
});
var A = n({
    strict: !1
  }),
  k = Object.keys(b),
  E = k.length;
var C = n({
    transformPagePoint: function transformPagePoint(e) {
      return e;
    },
    isStatic: !1
  }),
  T = n({});
var P = n(null);
function O(e) {
  var t = o(null);
  return null === t.current && (t.current = e()), t.current;
}
var R = 0,
  I = function I() {
    return R++;
  },
  M = function M() {
    return O(I);
  },
  V = n(null),
  _ = "undefined" != typeof window,
  N = _ ? a : i;
function j(e, t, n, a) {
  var s = r(C),
    u = r(A),
    c = r(T).visualElement,
    l = r(P),
    f = function (e) {
      var t = e.layoutId,
        n = r(V);
      return n && void 0 !== t ? n + "-" + t : t;
    }(n),
    d = o(void 0);
  a || (a = u.renderer), !d.current && a && (d.current = a(e, {
    visualState: t,
    parent: c,
    props: _p(_p({}, n), {
      layoutId: f
    }),
    presenceId: null == l ? void 0 : l.id,
    blockInitialAnimation: !1 === (null == l ? void 0 : l.initial)
  }));
  var v = d.current;
  return N(function () {
    var e;
    v && (v.setProps(_p(_p(_p({}, s), n), {
      layoutId: f
    })), v.isPresent = null === (e = l) || e.isPresent, v.isPresenceRoot = !c || c.presenceId !== (null == l ? void 0 : l.id), v.syncRender());
  }), i(function () {
    var e;
    v && (null === (e = v.animationState) || void 0 === e || e.animateChanges());
  }), N(function () {
    return function () {
      return null == v ? void 0 : v.notifyUnmount();
    };
  }, []), v;
}
function $(e, t, n) {
  return s(function (r) {
    var o, i;
    r && (null === (o = e.mount) || void 0 === o || o.call(e, r)), t && (r ? t.mount(r) : t.unmount()), n && ("function" == typeof n ? n(r) : "object" == typeof (i = n) && Object.prototype.hasOwnProperty.call(i, "current") && (n.current = r));
  }, [t]);
}
function L(e) {
  return Array.isArray(e);
}
function D(e) {
  return "string" == typeof e || L(e);
}
function z(e, t, n, r, o) {
  var i;
  return void 0 === r && (r = {}), void 0 === o && (o = {}), "string" == typeof t && (t = null === (i = e.variants) || void 0 === i ? void 0 : i[t]), "function" == typeof t ? t(null != n ? n : e.custom, r, o) : t;
}
function F(e, t, n) {
  var r = e.getProps();
  return z(r, t, null != n ? n : r.custom, function (e) {
    var t = {};
    return e.forEachValue(function (e, n) {
      return t[n] = e.get();
    }), t;
  }(e), function (e) {
    var t = {};
    return e.forEachValue(function (e, n) {
      return t[n] = e.getVelocity();
    }), t;
  }(e));
}
function B(e) {
  var t;
  return "function" == typeof (null === (t = e.animate) || void 0 === t ? void 0 : t.start) || D(e.initial) || D(e.animate) || D(e.whileHover) || D(e.whileDrag) || D(e.whileTap) || D(e.whileFocus) || D(e.exit);
}
function H(e) {
  return Boolean(B(e) || e.variants);
}
function U(e, t) {
  var n = function (e, t) {
      if (B(e)) {
        var n = e.initial,
          r = e.animate;
        return {
          initial: !1 === n || D(n) ? n : void 0,
          animate: D(r) ? r : void 0
        };
      }
      return !1 !== e.inherit ? t : {};
    }(e, r(T)),
    o = n.initial,
    i = n.animate;
  return u(function () {
    return {
      initial: o,
      animate: i
    };
  }, t ? [Y(o), Y(i)] : []);
}
function Y(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
function X(t) {
  var n = t.preloadedFeatures,
    o = t.createVisualElement,
    i = t.useRender,
    a = t.useVisualState,
    s = t.Component;
  return n && w(n), c(function (t, u) {
    var c = r(C).isStatic,
      l = null,
      f = U(t, c),
      d = a(t, c);
    return !c && _ && (f.visualElement = j(s, d, t, o), l = function (t, n, o) {
      var i = [],
        a = r(A);
      if (!n) return null;
      "production" !== process.env.NODE_ENV && o && a.strict && S(!1, "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.");
      for (var s = 0; s < E; s++) {
        var u = k[s],
          c = b[u],
          l = c.isEnabled,
          f = c.Component;
        l(t) && f && i.push(e.createElement(f, _p({
          key: u
        }, t, {
          visualElement: n
        })));
      }
      return i;
    }(t, f.visualElement, n)), e.createElement(e.Fragment, null, e.createElement(T.Provider, {
      value: f
    }, i(s, t, $(d, f.visualElement, u), d, c)), l);
  });
}
var q = ["animate", "circle", "defs", "desc", "ellipse", "g", "image", "line", "filter", "marker", "mask", "metadata", "path", "pattern", "polygon", "polyline", "rect", "stop", "svg", "switch", "symbol", "text", "tspan", "use", "view"];
function W(e) {
  return "string" == typeof e && !e.includes("-") && !!(q.indexOf(e) > -1 || /[A-Z]/.test(e));
}
var G = {},
  K = ["", "X", "Y", "Z"],
  Z = ["transformPerspective", "x", "y", "z"];
function J(e, t) {
  return Z.indexOf(e) - Z.indexOf(t);
}
["translate", "scale", "rotate", "skew"].forEach(function (e) {
  return K.forEach(function (t) {
    return Z.push(e + t);
  });
});
var Q = new Set(Z);
function ee(e) {
  return Q.has(e);
}
var te = new Set(["originX", "originY", "originZ"]);
function ne(e) {
  return te.has(e);
}
function re(e, t) {
  var n = t.layout,
    r = t.layoutId;
  return ee(e) || ne(e) || (n || void 0 !== r) && (!!G[e] || "opacity" === e);
}
var oe = function oe(e) {
    return null !== e && "object" == typeof e && e.getVelocity;
  },
  ie = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
  };
function ae(e) {
  return e.startsWith("--");
}
var se = function se(e, t) {
    return t && "number" == typeof e ? t.transform(e) : e;
  },
  ue = function ue(e, t) {
    return function (n) {
      return Math.max(Math.min(n, t), e);
    };
  },
  ce = function ce(e) {
    return e % 1 ? Number(e.toFixed(5)) : e;
  },
  le = /(-)?([\d]*\.?[\d])+/g,
  fe = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi,
  de = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function pe(e) {
  return "string" == typeof e;
}
var ve = {
    test: function test(e) {
      return "number" == typeof e;
    },
    parse: parseFloat,
    transform: function transform(e) {
      return e;
    }
  },
  me = _p(_p({}, ve), {
    transform: ue(0, 1)
  }),
  he = _p(_p({}, ve), {
    default: 1
  }),
  ye = function ye(e) {
    return {
      test: function test(t) {
        return pe(t) && t.endsWith(e) && 1 === t.split(" ").length;
      },
      parse: parseFloat,
      transform: function transform(t) {
        return "" + t + e;
      }
    };
  },
  ge = ye("deg"),
  be = ye("%"),
  we = ye("px"),
  xe = ye("vh"),
  Se = ye("vw"),
  Ae = _p(_p({}, be), {
    parse: function parse(e) {
      return be.parse(e) / 100;
    },
    transform: function transform(e) {
      return be.transform(100 * e);
    }
  }),
  ke = function ke(e, t) {
    return function (n) {
      return Boolean(pe(n) && de.test(n) && n.startsWith(e) || t && Object.prototype.hasOwnProperty.call(n, t));
    };
  },
  Ee = function Ee(e, t, n) {
    return function (r) {
      var o;
      if (!pe(r)) return r;
      var i = r.match(le),
        a = i[0],
        s = i[1],
        u = i[2],
        c = i[3];
      return (o = {})[e] = parseFloat(a), o[t] = parseFloat(s), o[n] = parseFloat(u), o.alpha = void 0 !== c ? parseFloat(c) : 1, o;
    };
  },
  Ce = {
    test: ke("hsl", "hue"),
    parse: Ee("hue", "saturation", "lightness"),
    transform: function transform(e) {
      var t = e.hue,
        n = e.saturation,
        r = e.lightness,
        o = e.alpha,
        i = void 0 === o ? 1 : o;
      return "hsla(" + Math.round(t) + ", " + be.transform(ce(n)) + ", " + be.transform(ce(r)) + ", " + ce(me.transform(i)) + ")";
    }
  },
  Te = ue(0, 255),
  Pe = _p(_p({}, ve), {
    transform: function transform(e) {
      return Math.round(Te(e));
    }
  }),
  Oe = {
    test: ke("rgb", "red"),
    parse: Ee("red", "green", "blue"),
    transform: function transform(e) {
      var t = e.red,
        n = e.green,
        r = e.blue,
        o = e.alpha,
        i = void 0 === o ? 1 : o;
      return "rgba(" + Pe.transform(t) + ", " + Pe.transform(n) + ", " + Pe.transform(r) + ", " + ce(me.transform(i)) + ")";
    }
  };
var Re = {
    test: ke("#"),
    parse: function parse(e) {
      var t = "",
        n = "",
        r = "",
        o = "";
      return e.length > 5 ? (t = e.substr(1, 2), n = e.substr(3, 2), r = e.substr(5, 2), o = e.substr(7, 2)) : (t = e.substr(1, 1), n = e.substr(2, 1), r = e.substr(3, 1), o = e.substr(4, 1), t += t, n += n, r += r, o += o), {
        red: parseInt(t, 16),
        green: parseInt(n, 16),
        blue: parseInt(r, 16),
        alpha: o ? parseInt(o, 16) / 255 : 1
      };
    },
    transform: Oe.transform
  },
  Ie = {
    test: function test(e) {
      return Oe.test(e) || Re.test(e) || Ce.test(e);
    },
    parse: function parse(e) {
      return Oe.test(e) ? Oe.parse(e) : Ce.test(e) ? Ce.parse(e) : Re.parse(e);
    },
    transform: function transform(e) {
      return pe(e) ? e : e.hasOwnProperty("red") ? Oe.transform(e) : Ce.transform(e);
    }
  };
function Me(e) {
  var t = [],
    n = 0,
    r = e.match(fe);
  r && (n = r.length, e = e.replace(fe, "${c}"), t.push.apply(t, r.map(Ie.parse)));
  var o = e.match(le);
  return o && (e = e.replace(le, "${n}"), t.push.apply(t, o.map(ve.parse))), {
    values: t,
    numColors: n,
    tokenised: e
  };
}
function Ve(e) {
  return Me(e).values;
}
function _e(e) {
  var t = Me(e),
    n = t.values,
    r = t.numColors,
    o = t.tokenised,
    i = n.length;
  return function (e) {
    for (var t = o, n = 0; n < i; n++) t = t.replace(n < r ? "${c}" : "${n}", n < r ? Ie.transform(e[n]) : ce(e[n]));
    return t;
  };
}
var Ne = function Ne(e) {
  return "number" == typeof e ? 0 : e;
};
var je = {
    test: function test(e) {
      var t, n, r, o;
      return isNaN(e) && pe(e) && (null !== (n = null === (t = e.match(le)) || void 0 === t ? void 0 : t.length) && void 0 !== n ? n : 0) + (null !== (o = null === (r = e.match(fe)) || void 0 === r ? void 0 : r.length) && void 0 !== o ? o : 0) > 0;
    },
    parse: Ve,
    createTransformer: _e,
    getAnimatableNone: function getAnimatableNone(e) {
      var t = Ve(e);
      return _e(e)(t.map(Ne));
    }
  },
  $e = new Set(["brightness", "contrast", "saturate", "opacity"]);
function Le(e) {
  var t = e.slice(0, -1).split("("),
    n = t[0],
    r = t[1];
  if ("drop-shadow" === n) return e;
  var o = (r.match(le) || [])[0];
  if (!o) return e;
  var i = r.replace(o, ""),
    a = $e.has(n) ? 1 : 0;
  return o !== r && (a *= 100), n + "(" + a + i + ")";
}
var De = /([a-z-]*)\(.*?\)/g,
  ze = _p(_p({}, je), {
    getAnimatableNone: function getAnimatableNone(e) {
      var t = e.match(De);
      return t ? t.map(Le).join(" ") : e;
    }
  }),
  Fe = _p(_p({}, ve), {
    transform: Math.round
  }),
  Be = {
    borderWidth: we,
    borderTopWidth: we,
    borderRightWidth: we,
    borderBottomWidth: we,
    borderLeftWidth: we,
    borderRadius: we,
    radius: we,
    borderTopLeftRadius: we,
    borderTopRightRadius: we,
    borderBottomRightRadius: we,
    borderBottomLeftRadius: we,
    width: we,
    maxWidth: we,
    height: we,
    maxHeight: we,
    size: we,
    top: we,
    right: we,
    bottom: we,
    left: we,
    padding: we,
    paddingTop: we,
    paddingRight: we,
    paddingBottom: we,
    paddingLeft: we,
    margin: we,
    marginTop: we,
    marginRight: we,
    marginBottom: we,
    marginLeft: we,
    rotate: ge,
    rotateX: ge,
    rotateY: ge,
    rotateZ: ge,
    scale: he,
    scaleX: he,
    scaleY: he,
    scaleZ: he,
    skew: ge,
    skewX: ge,
    skewY: ge,
    distance: we,
    translateX: we,
    translateY: we,
    translateZ: we,
    x: we,
    y: we,
    z: we,
    perspective: we,
    transformPerspective: we,
    opacity: me,
    originX: Ae,
    originY: Ae,
    originZ: we,
    zIndex: Fe,
    fillOpacity: me,
    strokeOpacity: me,
    numOctaves: Fe
  };
function He(e, t, n, r, o, i, a, s) {
  var u,
    c = e.style,
    l = e.vars,
    f = e.transform,
    d = e.transformKeys,
    p = e.transformOrigin;
  d.length = 0;
  var v = !1,
    m = !1,
    h = !0;
  for (var y in t) {
    var g = t[y];
    if (ae(y)) l[y] = g;else {
      var b = Be[y],
        w = se(g, b);
      if (ee(y)) {
        if (v = !0, f[y] = w, d.push(y), !h) continue;
        g !== (null !== (u = b.default) && void 0 !== u ? u : 0) && (h = !1);
      } else if (ne(y)) p[y] = w, m = !0;else if ((null == n ? void 0 : n.isHydrated) && (null == r ? void 0 : r.isHydrated) && G[y]) {
        var x = G[y].process(g, r, n),
          S = G[y].applyTo;
        if (S) for (var A = S.length, k = 0; k < A; k++) c[S[k]] = x;else c[y] = x;
      } else c[y] = w;
    }
  }
  r && n && a && s ? (c.transform = a(r.deltaFinal, r.treeScale, v ? f : void 0), i && (c.transform = i(f, c.transform)), c.transformOrigin = s(r)) : (v && (c.transform = function (e, t, n, r) {
    var o = e.transform,
      i = e.transformKeys,
      a = t.enableHardwareAcceleration,
      s = void 0 === a || a,
      u = t.allowTransformNone,
      c = void 0 === u || u,
      l = "";
    i.sort(J);
    for (var f = !1, d = i.length, p = 0; p < d; p++) {
      var v = i[p];
      l += (ie[v] || v) + "(" + o[v] + ") ", "z" === v && (f = !0);
    }
    return !f && s ? l += "translateZ(0)" : l = l.trim(), r ? l = r(o, n ? "" : l) : c && n && (l = "none"), l;
  }(e, o, h, i)), m && (c.transformOrigin = function (e) {
    var t = e.originX,
      n = void 0 === t ? "50%" : t,
      r = e.originY,
      o = void 0 === r ? "50%" : r,
      i = e.originZ;
    return n + " " + o + " " + (void 0 === i ? 0 : i);
  }(p)));
}
var Ue = function Ue() {
  return {
    style: {},
    transform: {},
    transformKeys: [],
    transformOrigin: {},
    vars: {}
  };
};
function Ye(e, t, n) {
  for (var r in t) oe(t[r]) || re(r, n) || (e[r] = t[r]);
}
function Xe(e, t, n) {
  var r = {};
  return Ye(r, e.style || {}, e), Object.assign(r, function (e, t, n) {
    var r = e.transformTemplate;
    return u(function () {
      var e = {
        style: {},
        transform: {},
        transformKeys: [],
        transformOrigin: {},
        vars: {}
      };
      He(e, t, void 0, void 0, {
        enableHardwareAcceleration: !n
      }, r);
      var o = e.style;
      return _p(_p({}, e.vars), o);
    }, [t]);
  }(e, t, n)), e.transformValues && (r = e.transformValues(r)), r;
}
function qe(e, t, n) {
  var r = {},
    o = Xe(e, t, n);
  return Boolean(e.drag) && (r.draggable = !1, o.userSelect = o.WebkitUserSelect = o.WebkitTouchCallout = "none", o.touchAction = !0 === e.drag ? "none" : "pan-" + ("x" === e.drag ? "y" : "x")), r.style = o, r;
}
var We = new Set(["initial", "animate", "exit", "style", "variants", "transition", "transformTemplate", "transformValues", "custom", "inherit", "layout", "layoutId", "_layoutResetTransform", "onLayoutAnimationComplete", "onViewportBoxUpdate", "onLayoutMeasure", "onBeforeLayoutMeasure", "onAnimationStart", "onAnimationComplete", "onUpdate", "onDragStart", "onDrag", "onDragEnd", "onMeasureDragConstraints", "onDirectionLock", "onDragTransitionEnd", "drag", "dragControls", "dragListener", "dragConstraints", "dragDirectionLock", "_dragX", "_dragY", "dragElastic", "dragMomentum", "dragPropagation", "dragTransition", "whileDrag", "onPan", "onPanStart", "onPanEnd", "onPanSessionStart", "onTap", "onTapStart", "onTapCancel", "onHoverStart", "onHoverEnd", "whileFocus", "whileTap", "whileHover"]);
function Ge(e) {
  return We.has(e);
}
var Ke = function Ke(e) {
  return !Ge(e);
};
try {
  var Ze = require("@emotion/is-prop-valid").default;
  Ke = function Ke(e) {
    return e.startsWith("on") ? !Ge(e) : Ze(e);
  };
} catch (e) {}
function Je(e, t, n) {
  return "string" == typeof e ? e : we.transform(t + n * e);
}
var Qe = function Qe(e, t) {
    return we.transform(e * t);
  },
  et = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
  },
  tt = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
  };
function nt(e, t, n, r, o, i, a, s) {
  var u = t.attrX,
    c = t.attrY,
    l = t.originX,
    f = t.originY,
    d = t.pathLength,
    p = t.pathSpacing,
    m = void 0 === p ? 1 : p,
    h = t.pathOffset,
    y = void 0 === h ? 0 : h;
  He(e, v(t, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]), n, r, o, i, a, s), e.attrs = e.style, e.style = {};
  var g = e.attrs,
    b = e.style,
    w = e.dimensions,
    x = e.totalPathLength;
  g.transform && (w && (b.transform = g.transform), delete g.transform), w && (void 0 !== l || void 0 !== f || b.transform) && (b.transformOrigin = function (e, t, n) {
    return Je(t, e.x, e.width) + " " + Je(n, e.y, e.height);
  }(w, void 0 !== l ? l : .5, void 0 !== f ? f : .5)), void 0 !== u && (g.x = u), void 0 !== c && (g.y = c), void 0 !== x && void 0 !== d && function (e, t, n, r, o, i) {
    void 0 === r && (r = 1), void 0 === o && (o = 0), void 0 === i && (i = !0);
    var a = i ? et : tt;
    e[a.offset] = Qe(-o, t);
    var s = Qe(n, t),
      u = Qe(r, t);
    e[a.array] = s + " " + u;
  }(g, x, d, m, y, !1);
}
var rt = function rt() {
  return _p(_p({}, {
    style: {},
    transform: {},
    transformKeys: [],
    transformOrigin: {},
    vars: {}
  }), {
    attrs: {}
  });
};
function ot(e, t) {
  var n = u(function () {
    var n = rt();
    return nt(n, t, void 0, void 0, {
      enableHardwareAcceleration: !1
    }, e.transformTemplate), _p(_p({}, n.attrs), {
      style: _p({}, n.style)
    });
  }, [t]);
  if (e.style) {
    var r = {};
    Ye(r, e.style, e), n.style = _p(_p({}, r), n.style);
  }
  return n;
}
function it(e) {
  void 0 === e && (e = !1);
  return function (t, n, r, o, i) {
    var a = o.latestValues,
      s = (W(t) ? ot : qe)(n, a, i),
      u = function (e, t, n) {
        var r = {};
        for (var o in e) (Ke(o) || !0 === n && Ge(o) || !t && !Ge(o)) && (r[o] = e[o]);
        return r;
      }(n, "string" == typeof t, e),
      c = _p(_p(_p({}, u), s), {
        ref: r
      });
    return l(t, c);
  };
}
var at = /([a-z])([A-Z])/g,
  st = function st(e) {
    return e.replace(at, "$1-$2").toLowerCase();
  };
function ut(e, t) {
  var n = t.style,
    r = t.vars;
  for (var o in Object.assign(e.style, n), r) e.style.setProperty(o, r[o]);
}
var ct = new Set(["baseFrequency", "diffuseConstant", "kernelMatrix", "kernelUnitLength", "keySplines", "keyTimes", "limitingConeAngle", "markerHeight", "markerWidth", "numOctaves", "targetX", "targetY", "surfaceScale", "specularConstant", "specularExponent", "stdDeviation", "tableValues", "viewBox", "gradientTransform"]);
function lt(e, t) {
  for (var n in ut(e, t), t.attrs) e.setAttribute(ct.has(n) ? n : st(n), t.attrs[n]);
}
function ft(e) {
  var t = e.style,
    n = {};
  for (var r in t) (oe(t[r]) || re(r, e)) && (n[r] = t[r]);
  return n;
}
function dt(e) {
  var t = ft(e);
  for (var n in e) {
    if (oe(e[n])) t["x" === n || "y" === n ? "attr" + n.toUpperCase() : n] = e[n];
  }
  return t;
}
function pt(e) {
  return "object" == typeof e && "function" == typeof e.start;
}
var vt = function vt(e) {
    return Array.isArray(e);
  },
  mt = function mt(e) {
    return vt(e) ? e[e.length - 1] || 0 : e;
  };
function ht(e) {
  var t = oe(e) ? e.get() : e;
  return function (e) {
    return Boolean(e && "object" == typeof e && e.mix && e.toValue);
  }(t) ? t.toValue() : t;
}
function yt(e, t, n, r) {
  var o = e.scrapeMotionValuesFromProps,
    i = e.createRenderState,
    a = e.onMount,
    s = {
      latestValues: bt(t, n, r, o),
      renderState: i()
    };
  return a && (s.mount = function (e) {
    return a(t, e, s);
  }), s;
}
var gt = function gt(e) {
  return function (t, n) {
    var o = r(T),
      i = r(P);
    return n ? yt(e, t, o, i) : O(function () {
      return yt(e, t, o, i);
    });
  };
};
function bt(e, t, n, r) {
  var o = {},
    i = !1 === (null == n ? void 0 : n.initial),
    a = r(e);
  for (var s in a) o[s] = ht(a[s]);
  var u = e.initial,
    c = e.animate,
    l = B(e),
    f = H(e);
  t && f && !l && !1 !== e.inherit && (null != u || (u = t.initial), null != c || (c = t.animate));
  var d = i || !1 === u ? c : u;
  d && "boolean" != typeof d && !pt(d) && (Array.isArray(d) ? d : [d]).forEach(function (t) {
    var n = z(e, t);
    if (n) {
      var r = n.transitionEnd;
      n.transition;
      var i = v(n, ["transitionEnd", "transition"]);
      for (var a in i) o[a] = i[a];
      for (var a in r) o[a] = r[a];
    }
  });
  return o;
}
var wt = {
  useVisualState: gt({
    scrapeMotionValuesFromProps: dt,
    createRenderState: rt,
    onMount: function onMount(e, t, n) {
      var r = n.renderState,
        o = n.latestValues;
      try {
        r.dimensions = "function" == typeof t.getBBox ? t.getBBox() : t.getBoundingClientRect();
      } catch (e) {
        r.dimensions = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }
      "path" === t.tagName && (r.totalPathLength = t.getTotalLength()), nt(r, o, void 0, void 0, {
        enableHardwareAcceleration: !1
      }, e.transformTemplate), lt(t, r);
    }
  })
};
var xt,
  St = {
    useVisualState: gt({
      scrapeMotionValuesFromProps: ft,
      createRenderState: Ue
    })
  };
function At(e, t, n, r) {
  return e.addEventListener(t, n, r), function () {
    return e.removeEventListener(t, n, r);
  };
}
function kt(e, t, n, r) {
  i(function () {
    var o = e.current;
    if (n && o) return At(o, t, n, r);
  }, [e, t, n, r]);
}
function Et(e) {
  return !!e.touches;
}
!function (e) {
  e.Animate = "animate", e.Hover = "whileHover", e.Tap = "whileTap", e.Drag = "whileDrag", e.Focus = "whileFocus", e.Exit = "exit";
}(xt || (xt = {}));
var Ct = {
  pageX: 0,
  pageY: 0
};
function Tt(e, t) {
  void 0 === t && (t = "page");
  var n = e.touches[0] || e.changedTouches[0] || Ct;
  return {
    x: n[t + "X"],
    y: n[t + "Y"]
  };
}
function Pt(e, t) {
  return void 0 === t && (t = "page"), {
    x: e[t + "X"],
    y: e[t + "Y"]
  };
}
var Ot = function Ot(e, t) {
    void 0 === t && (t = !1);
    var n,
      r = function r(t) {
        return e(t, function (e, t) {
          return void 0 === t && (t = "page"), {
            point: Et(e) ? Tt(e, t) : Pt(e, t)
          };
        }(t));
      };
    return t ? (n = r, function (e) {
      var t = e instanceof MouseEvent;
      (!t || t && 0 === e.button) && n(e);
    }) : r;
  },
  Rt = {
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointercancel: "mousecancel",
    pointerover: "mouseover",
    pointerout: "mouseout",
    pointerenter: "mouseenter",
    pointerleave: "mouseleave"
  },
  It = {
    pointerdown: "touchstart",
    pointermove: "touchmove",
    pointerup: "touchend",
    pointercancel: "touchcancel"
  };
function Mt(e) {
  return _ && null === window.onpointerdown ? e : _ && null === window.ontouchstart ? It[e] : _ && null === window.onmousedown ? Rt[e] : e;
}
function Vt(e, t, n, r) {
  return At(e, Mt(t), Ot(n, "pointerdown" === t), r);
}
function _t(e, t, n, r) {
  return kt(e, Mt(t), n && Ot(n, "pointerdown" === t), r);
}
function Nt(e) {
  var t = null;
  return function () {
    return null === t && (t = e, function () {
      t = null;
    });
  };
}
var jt = Nt("dragHorizontal"),
  $t = Nt("dragVertical");
function Lt() {
  var e = function (e) {
    var t = !1;
    if ("y" === e) t = $t();else if ("x" === e) t = jt();else {
      var n = jt(),
        r = $t();
      n && r ? t = function t() {
        n(), r();
      } : (n && n(), r && r());
    }
    return t;
  }(!0);
  return !e || (e(), !1);
}
function Dt(e, t, n) {
  return function (r, o) {
    var i;
    (function (e) {
      return "undefined" != typeof PointerEvent && e instanceof PointerEvent ? !("mouse" !== e.pointerType) : e instanceof MouseEvent;
    })(r) && !Lt() && (null == n || n(r, o), null === (i = e.animationState) || void 0 === i || i.setActive(xt.Hover, t));
  };
}
var _zt = function zt(e, t) {
  return !!t && (e === t || _zt(e, t.parentElement));
};
var Ft = function Ft(e, t, n) {
  return Math.min(Math.max(n, e), t);
};
function Bt(e) {
  var t,
    n,
    r = e.duration,
    o = void 0 === r ? 800 : r,
    i = e.bounce,
    a = void 0 === i ? .25 : i,
    s = e.velocity,
    u = void 0 === s ? 0 : s,
    c = e.mass,
    l = void 0 === c ? 1 : c;
  x(o <= 1e4, "Spring duration must be 10 seconds or less");
  var f = 1 - a;
  f = Ft(.05, 1, f), o = Ft(.01, 10, o / 1e3), f < 1 ? (t = function t(e) {
    var t = e * f,
      n = t * o;
    return .001 - (t - u) / Ht(e, f) * Math.exp(-n);
  }, n = function n(e) {
    var n = e * f * o,
      r = n * u + u,
      i = Math.pow(f, 2) * Math.pow(e, 2) * o,
      a = Math.exp(-n),
      s = Ht(Math.pow(e, 2), f);
    return (.001 - t(e) > 0 ? -1 : 1) * ((r - i) * a) / s;
  }) : (t = function t(e) {
    return Math.exp(-e * o) * ((e - u) * o + 1) - .001;
  }, n = function n(e) {
    return Math.exp(-e * o) * (o * o * (u - e));
  });
  var d = function (e, t, n) {
    for (var r = n, o = 1; o < 12; o++) r -= e(r) / t(r);
    return r;
  }(t, n, 5 / o);
  if (o *= 1e3, isNaN(d)) return {
    stiffness: 100,
    damping: 10,
    duration: o
  };
  var p = Math.pow(d, 2) * l;
  return {
    stiffness: p,
    damping: 2 * f * Math.sqrt(l * p),
    duration: o
  };
}
function Ht(e, t) {
  return e * Math.sqrt(1 - t * t);
}
var Ut = ["duration", "bounce"],
  Yt = ["stiffness", "damping", "mass"];
function Xt(e, t) {
  return t.some(function (t) {
    return void 0 !== e[t];
  });
}
function qt(e) {
  var t = e.from,
    n = void 0 === t ? 0 : t,
    r = e.to,
    o = void 0 === r ? 1 : r,
    i = e.restSpeed,
    a = void 0 === i ? 2 : i,
    s = e.restDelta,
    u = v(e, ["from", "to", "restSpeed", "restDelta"]),
    c = {
      done: !1,
      value: n
    },
    l = function (e) {
      var t = _p({
        velocity: 0,
        stiffness: 100,
        damping: 10,
        mass: 1,
        isResolvedFromDuration: !1
      }, e);
      if (!Xt(e, Yt) && Xt(e, Ut)) {
        var n = Bt(e);
        (t = _p(_p(_p({}, t), n), {
          velocity: 0,
          mass: 1
        })).isResolvedFromDuration = !0;
      }
      return t;
    }(u),
    f = l.stiffness,
    d = l.damping,
    m = l.mass,
    h = l.velocity,
    y = l.duration,
    g = l.isResolvedFromDuration,
    b = Wt,
    w = Wt;
  function x() {
    var e = h ? -h / 1e3 : 0,
      t = o - n,
      r = d / (2 * Math.sqrt(f * m)),
      i = Math.sqrt(f / m) / 1e3;
    if (null != s || (s = Math.abs(o - n) <= 1 ? .01 : .4), r < 1) {
      var a = Ht(i, r);
      b = function b(n) {
        var s = Math.exp(-r * i * n);
        return o - s * ((e + r * i * t) / a * Math.sin(a * n) + t * Math.cos(a * n));
      }, w = function w(n) {
        var o = Math.exp(-r * i * n);
        return r * i * o * (Math.sin(a * n) * (e + r * i * t) / a + t * Math.cos(a * n)) - o * (Math.cos(a * n) * (e + r * i * t) - a * t * Math.sin(a * n));
      };
    } else if (1 === r) b = function b(n) {
      return o - Math.exp(-i * n) * (t + (e + i * t) * n);
    };else {
      var u = i * Math.sqrt(r * r - 1);
      b = function b(n) {
        var a = Math.exp(-r * i * n),
          s = Math.min(u * n, 300);
        return o - a * ((e + r * i * t) * Math.sinh(s) + u * t * Math.cosh(s)) / u;
      };
    }
  }
  return x(), {
    next: function next(e) {
      var t = b(e);
      if (g) c.done = e >= y;else {
        var n = 1e3 * w(e),
          r = Math.abs(n) <= a,
          i = Math.abs(o - t) <= s;
        c.done = r && i;
      }
      return c.value = c.done ? o : t, c;
    },
    flipTarget: function flipTarget() {
      var e;
      h = -h, n = (e = [o, n])[0], o = e[1], x();
    }
  };
}
qt.needsInterpolation = function (e, t) {
  return "string" == typeof e || "string" == typeof t;
};
var Wt = function Wt(e) {
    return 0;
  },
  Gt = function Gt(e, t, n) {
    var r = t - e;
    return 0 === r ? 1 : (n - e) / r;
  },
  Kt = function Kt(e, t, n) {
    return -n * e + n * t + e;
  },
  Zt = function Zt(e, t, n) {
    var r = e * e,
      o = t * t;
    return Math.sqrt(Math.max(0, n * (o - r) + r));
  },
  Jt = [Re, Oe, Ce],
  Qt = function Qt(e) {
    return Jt.find(function (t) {
      return t.test(e);
    });
  },
  en = function en(e) {
    return "'" + e + "' is not an animatable color. Use the equivalent color code instead.";
  },
  tn = function tn(e, t) {
    var n = Qt(e),
      r = Qt(t);
    S(!!n, en(e)), S(!!r, en(t)), S(n.transform === r.transform, "Both colors must be hex/RGBA, OR both must be HSLA.");
    var o = n.parse(e),
      i = r.parse(t),
      a = _p({}, o),
      s = n === Ce ? Kt : Zt;
    return function (e) {
      for (var t in a) "alpha" !== t && (a[t] = s(o[t], i[t], e));
      return a.alpha = Kt(o.alpha, i.alpha, e), n.transform(a);
    };
  },
  nn = function nn(e) {
    return "number" == typeof e;
  },
  rn = function rn(e, t) {
    return function (n) {
      return t(e(n));
    };
  },
  on = function on() {
    for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
    return e.reduce(rn);
  };
function an(e, t) {
  return nn(e) ? function (n) {
    return Kt(e, t, n);
  } : Ie.test(e) ? tn(e, t) : ln(e, t);
}
var sn = function sn(e, t) {
    var n = h([], e),
      r = n.length,
      o = e.map(function (e, n) {
        return an(e, t[n]);
      });
    return function (e) {
      for (var t = 0; t < r; t++) n[t] = o[t](e);
      return n;
    };
  },
  un = function un(e, t) {
    var n = _p(_p({}, e), t),
      r = {};
    for (var o in n) void 0 !== e[o] && void 0 !== t[o] && (r[o] = an(e[o], t[o]));
    return function (e) {
      for (var t in r) n[t] = r[t](e);
      return n;
    };
  };
function cn(e) {
  for (var t = je.parse(e), n = t.length, r = 0, o = 0, i = 0, a = 0; a < n; a++) r || "number" == typeof t[a] ? r++ : void 0 !== t[a].hue ? i++ : o++;
  return {
    parsed: t,
    numNumbers: r,
    numRGB: o,
    numHSL: i
  };
}
var ln = function ln(e, t) {
    var n = je.createTransformer(t),
      r = cn(e),
      o = cn(t);
    return S(r.numHSL === o.numHSL && r.numRGB === o.numRGB && r.numNumbers >= o.numNumbers, "Complex values '" + e + "' and '" + t + "' too different to mix. Ensure all colors are of the same type."), on(sn(r.parsed, o.parsed), n);
  },
  fn = function fn(e, t) {
    return function (n) {
      return Kt(e, t, n);
    };
  };
function dn(e, t, n) {
  for (var r = [], o = n || function (e) {
      return "number" == typeof e ? fn : "string" == typeof e ? Ie.test(e) ? tn : ln : Array.isArray(e) ? sn : "object" == typeof e ? un : void 0;
    }(e[0]), i = e.length - 1, a = 0; a < i; a++) {
    var s = o(e[a], e[a + 1]);
    if (t) {
      var u = Array.isArray(t) ? t[a] : t;
      s = on(u, s);
    }
    r.push(s);
  }
  return r;
}
function pn(e, t, n) {
  var r = void 0 === n ? {} : n,
    o = r.clamp,
    i = void 0 === o || o,
    a = r.ease,
    s = r.mixer,
    u = e.length;
  S(u === t.length, "Both input and output ranges must be the same length"), S(!a || !Array.isArray(a) || a.length === u - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values."), e[0] > e[u - 1] && (e = [].concat(e), t = [].concat(t), e.reverse(), t.reverse());
  var c = dn(t, a, s),
    l = 2 === u ? function (e, t) {
      var n = e[0],
        r = e[1],
        o = t[0];
      return function (e) {
        return o(Gt(n, r, e));
      };
    }(e, c) : function (e, t) {
      var n = e.length,
        r = n - 1;
      return function (o) {
        var i = 0,
          a = !1;
        if (o <= e[0] ? a = !0 : o >= e[r] && (i = r - 1, a = !0), !a) {
          for (var s = 1; s < n && !(e[s] > o || s === r); s++);
          i = s - 1;
        }
        var u = Gt(e[i], e[i + 1], o);
        return t[i](u);
      };
    }(e, c);
  return i ? function (t) {
    return l(Ft(e[0], e[u - 1], t));
  } : l;
}
var vn,
  mn = function mn(e) {
    return function (t) {
      return 1 - e(1 - t);
    };
  },
  hn = function hn(e) {
    return function (t) {
      return t <= .5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2;
    };
  },
  yn = function yn(e) {
    return function (t) {
      return t * t * ((e + 1) * t - e);
    };
  },
  gn = function gn(e) {
    return e;
  },
  bn = (vn = 2, function (e) {
    return Math.pow(e, vn);
  }),
  wn = mn(bn),
  xn = hn(bn),
  Sn = function Sn(e) {
    return 1 - Math.sin(Math.acos(e));
  },
  An = mn(Sn),
  kn = hn(An),
  En = yn(1.525),
  Cn = mn(En),
  Tn = hn(En),
  Pn = function (e) {
    var t = yn(e);
    return function (e) {
      return (e *= 2) < 1 ? .5 * t(e) : .5 * (2 - Math.pow(2, -10 * (e - 1)));
    };
  }(1.525),
  On = function On(e) {
    if (1 === e || 0 === e) return e;
    var t = e * e;
    return e < .36363636363636365 ? 7.5625 * t : e < .7272727272727273 ? 9.075 * t - 9.9 * e + 3.4 : e < .9 ? 12.066481994459833 * t - 19.63545706371191 * e + 8.898060941828255 : 10.8 * e * e - 20.52 * e + 10.72;
  },
  Rn = mn(On);
function In(e, t) {
  return e.map(function () {
    return t || xn;
  }).splice(0, e.length - 1);
}
function Mn(e) {
  var t = e.from,
    n = void 0 === t ? 0 : t,
    r = e.to,
    o = void 0 === r ? 1 : r,
    i = e.ease,
    a = e.offset,
    s = e.duration,
    u = void 0 === s ? 300 : s,
    c = {
      done: !1,
      value: n
    },
    l = Array.isArray(o) ? o : [n, o],
    f = function (e, t) {
      return e.map(function (e) {
        return e * t;
      });
    }(a && a.length === l.length ? a : function (e) {
      var t = e.length;
      return e.map(function (e, n) {
        return 0 !== n ? n / (t - 1) : 0;
      });
    }(l), u);
  function d() {
    return pn(f, l, {
      ease: Array.isArray(i) ? i : In(l, i)
    });
  }
  var p = d();
  return {
    next: function next(e) {
      return c.value = p(e), c.done = e >= u, c;
    },
    flipTarget: function flipTarget() {
      l.reverse(), p = d();
    }
  };
}
var Vn = {
  keyframes: Mn,
  spring: qt,
  decay: function decay(e) {
    var t = e.velocity,
      n = void 0 === t ? 0 : t,
      r = e.from,
      o = void 0 === r ? 0 : r,
      i = e.power,
      a = void 0 === i ? .8 : i,
      s = e.timeConstant,
      u = void 0 === s ? 350 : s,
      c = e.restDelta,
      l = void 0 === c ? .5 : c,
      f = e.modifyTarget,
      d = {
        done: !1,
        value: o
      },
      p = a * n,
      v = o + p,
      m = void 0 === f ? v : f(v);
    return m !== v && (p = m - o), {
      next: function next(e) {
        var t = -p * Math.exp(-e / u);
        return d.done = !(t > l || t < -l), d.value = d.done ? m : m + t, d;
      },
      flipTarget: function flipTarget() {}
    };
  }
};
var _n = "undefined" != typeof performance ? function () {
    return performance.now();
  } : function () {
    return Date.now();
  },
  Nn = "undefined" != typeof window ? function (e) {
    return window.requestAnimationFrame(e);
  } : function (e) {
    return setTimeout(function () {
      return e(_n());
    }, 16.666666666666668);
  };
var jn = !0,
  $n = !1,
  Ln = !1,
  Dn = {
    delta: 0,
    timestamp: 0
  },
  zn = ["read", "update", "preRender", "render", "postRender"],
  Fn = zn.reduce(function (e, t) {
    return e[t] = function (e) {
      var t = [],
        n = [],
        r = 0,
        o = !1,
        i = new WeakSet(),
        a = {
          schedule: function schedule(e, a, s) {
            void 0 === a && (a = !1), void 0 === s && (s = !1);
            var u = s && o,
              c = u ? t : n;
            return a && i.add(e), -1 === c.indexOf(e) && (c.push(e), u && o && (r = t.length)), e;
          },
          cancel: function cancel(e) {
            var t = n.indexOf(e);
            -1 !== t && n.splice(t, 1), i.delete(e);
          },
          process: function process(s) {
            var u;
            if (o = !0, t = (u = [n, t])[0], (n = u[1]).length = 0, r = t.length) for (var c = 0; c < r; c++) {
              var l = t[c];
              l(s), i.has(l) && (a.schedule(l), e());
            }
            o = !1;
          }
        };
      return a;
    }(function () {
      return $n = !0;
    }), e;
  }, {}),
  Bn = zn.reduce(function (e, t) {
    var n = Fn[t];
    return e[t] = function (e, t, r) {
      return void 0 === t && (t = !1), void 0 === r && (r = !1), $n || Xn(), n.schedule(e, t, r);
    }, e;
  }, {}),
  Hn = zn.reduce(function (e, t) {
    return e[t] = Fn[t].cancel, e;
  }, {}),
  Un = function Un(e) {
    return Fn[e].process(Dn);
  },
  _Yn = function Yn(e) {
    $n = !1, Dn.delta = jn ? 16.666666666666668 : Math.max(Math.min(e - Dn.timestamp, 40), 1), Dn.timestamp = e, Ln = !0, zn.forEach(Un), Ln = !1, $n && (jn = !1, Nn(_Yn));
  },
  Xn = function Xn() {
    $n = !0, jn = !0, Ln || Nn(_Yn);
  },
  qn = function qn() {
    return Dn;
  };
function Wn(e, t, n) {
  return void 0 === n && (n = 0), e - t - n;
}
var Gn = function Gn(e) {
  var t = function t(_t2) {
    var n = _t2.delta;
    return e(n);
  };
  return {
    start: function start() {
      return Bn.update(t, !0);
    },
    stop: function stop() {
      return Hn.update(t);
    }
  };
};
function Kn(e) {
  var t,
    n,
    r,
    o,
    i,
    a = e.from,
    s = e.autoplay,
    u = void 0 === s || s,
    c = e.driver,
    l = void 0 === c ? Gn : c,
    f = e.elapsed,
    d = void 0 === f ? 0 : f,
    m = e.repeat,
    h = void 0 === m ? 0 : m,
    y = e.repeatType,
    g = void 0 === y ? "loop" : y,
    b = e.repeatDelay,
    w = void 0 === b ? 0 : b,
    x = e.onPlay,
    S = e.onStop,
    A = e.onComplete,
    k = e.onRepeat,
    E = e.onUpdate,
    C = v(e, ["from", "autoplay", "driver", "elapsed", "repeat", "repeatType", "repeatDelay", "onPlay", "onStop", "onComplete", "onRepeat", "onUpdate"]),
    T = C.to,
    P = 0,
    O = C.duration,
    R = !1,
    I = !0,
    M = function (e) {
      if (Array.isArray(e.to)) return Mn;
      if (Vn[e.type]) return Vn[e.type];
      var t = new Set(Object.keys(e));
      return t.has("ease") || t.has("duration") && !t.has("dampingRatio") ? Mn : t.has("dampingRatio") || t.has("stiffness") || t.has("mass") || t.has("damping") || t.has("restSpeed") || t.has("restDelta") ? qt : Mn;
    }(C);
  (null === (n = (t = M).needsInterpolation) || void 0 === n ? void 0 : n.call(t, a, T)) && (i = pn([0, 100], [a, T], {
    clamp: !1
  }), a = 0, T = 100);
  var V = M(_p(_p({}, C), {
    from: a,
    to: T
  }));
  function _() {
    P++, "reverse" === g ? d = function (e, t, n, r) {
      return void 0 === n && (n = 0), void 0 === r && (r = !0), r ? Wn(t + -e, t, n) : t - (e - t) + n;
    }(d, O, w, I = P % 2 == 0) : (d = Wn(d, O, w), "mirror" === g && V.flipTarget()), R = !1, k && k();
  }
  function N(e) {
    if (I || (e = -e), d += e, !R) {
      var t = V.next(Math.max(0, d));
      o = t.value, i && (o = i(o)), R = I ? t.done : d <= 0;
    }
    null == E || E(o), R && (0 === P && (null != O || (O = d)), P < h ? function (e, t, n, r) {
      return r ? e >= t + n : e <= -n;
    }(d, O, w, I) && _() : (r.stop(), A && A()));
  }
  return u && (null == x || x(), (r = l(N)).start()), {
    stop: function stop() {
      null == S || S(), r.stop();
    }
  };
}
function Zn(e, t) {
  return t ? e * (1e3 / t) : 0;
}
var Jn = function Jn(e) {
    return e.hasOwnProperty("x") && e.hasOwnProperty("y");
  },
  Qn = function Qn(e) {
    return Jn(e) && e.hasOwnProperty("z");
  },
  er = function er(e, t) {
    return Math.abs(e - t);
  };
var tr = function tr(e, t) {
    return 1 - 3 * t + 3 * e;
  },
  nr = function nr(e, t) {
    return 3 * t - 6 * e;
  },
  rr = function rr(e) {
    return 3 * e;
  },
  or = function or(e, t, n) {
    return ((tr(t, n) * e + nr(t, n)) * e + rr(t)) * e;
  },
  ir = function ir(e, t, n) {
    return 3 * tr(t, n) * e * e + 2 * nr(t, n) * e + rr(t);
  };
function ar(e, t, n, r) {
  if (e === t && n === r) return gn;
  for (var o = new Float32Array(11), i = 0; i < 11; ++i) o[i] = or(.1 * i, e, n);
  function a(t) {
    for (var r = 0, i = 1; 10 !== i && o[i] <= t; ++i) r += .1;
    --i;
    var a = r + .1 * ((t - o[i]) / (o[i + 1] - o[i])),
      s = ir(a, e, n);
    return s >= .001 ? function (e, t, n, r) {
      for (var o = 0; o < 8; ++o) {
        var i = ir(t, n, r);
        if (0 === i) return t;
        t -= (or(t, n, r) - e) / i;
      }
      return t;
    }(t, a, e, n) : 0 === s ? a : function (e, t, n, r, o) {
      var i,
        a,
        s = 0;
      do {
        (i = or(a = t + (n - t) / 2, r, o) - e) > 0 ? n = a : t = a;
      } while (Math.abs(i) > 1e-7 && ++s < 10);
      return a;
    }(t, r, r + .1, e, n);
  }
  return function (e) {
    return 0 === e || 1 === e ? e : or(a(e), t, r);
  };
}
var sr = function sr(e) {
    return function (t) {
      return e(t), null;
    };
  },
  ur = {
    tap: sr(function (e) {
      var t,
        n = e.onTap,
        r = e.onTapStart,
        a = e.onTapCancel,
        s = e.whileTap,
        u = e.visualElement,
        c = n || r || a || s,
        l = o(!1),
        f = o(null);
      function d() {
        var e;
        null === (e = f.current) || void 0 === e || e.call(f), f.current = null;
      }
      function p() {
        var e;
        return d(), l.current = !1, null === (e = u.animationState) || void 0 === e || e.setActive(xt.Tap, !1), !Lt();
      }
      function v(e, t) {
        p() && (_zt(u.getInstance(), e.target) ? null == n || n(e, t) : null == a || a(e, t));
      }
      function m(e, t) {
        p() && (null == a || a(e, t));
      }
      _t(u, "pointerdown", c ? function (e, t) {
        var n;
        d(), l.current || (l.current = !0, f.current = on(Vt(window, "pointerup", v), Vt(window, "pointercancel", m)), null == r || r(e, t), null === (n = u.animationState) || void 0 === n || n.setActive(xt.Tap, !0));
      } : void 0), t = d, i(function () {
        return function () {
          return t();
        };
      }, []);
    }),
    focus: sr(function (e) {
      var t = e.whileFocus,
        n = e.visualElement;
      kt(n, "focus", t ? function () {
        var e;
        null === (e = n.animationState) || void 0 === e || e.setActive(xt.Focus, !0);
      } : void 0), kt(n, "blur", t ? function () {
        var e;
        null === (e = n.animationState) || void 0 === e || e.setActive(xt.Focus, !1);
      } : void 0);
    }),
    hover: sr(function (e) {
      var t = e.onHoverStart,
        n = e.onHoverEnd,
        r = e.whileHover,
        o = e.visualElement;
      _t(o, "pointerenter", t || r ? Dt(o, !0, t) : void 0), _t(o, "pointerleave", n || r ? Dt(o, !1, n) : void 0);
    })
  };
function cr(e, t) {
  if (!Array.isArray(t)) return !1;
  var n = t.length;
  if (n !== e.length) return !1;
  for (var r = 0; r < n; r++) if (t[r] !== e[r]) return !1;
  return !0;
}
var lr = function lr(e) {
    return 1e3 * e;
  },
  fr = {
    linear: gn,
    easeIn: bn,
    easeInOut: xn,
    easeOut: wn,
    circIn: Sn,
    circInOut: kn,
    circOut: An,
    backIn: En,
    backInOut: Tn,
    backOut: Cn,
    anticipate: Pn,
    bounceIn: Rn,
    bounceInOut: function bounceInOut(e) {
      return e < .5 ? .5 * (1 - On(1 - 2 * e)) : .5 * On(2 * e - 1) + .5;
    },
    bounceOut: On
  },
  dr = function dr(e) {
    if (Array.isArray(e)) {
      S(4 === e.length, "Cubic bezier arrays must contain four numerical values.");
      var t = m(e, 4);
      return ar(t[0], t[1], t[2], t[3]);
    }
    return "string" == typeof e ? (S(void 0 !== fr[e], "Invalid easing type '" + e + "'"), fr[e]) : e;
  },
  pr = function pr(e, t) {
    return "zIndex" !== e && (!("number" != typeof t && !Array.isArray(t)) || !("string" != typeof t || !je.test(t) || t.startsWith("url(")));
  },
  vr = function vr() {
    return {
      type: "spring",
      stiffness: 500,
      damping: 25,
      restDelta: .5,
      restSpeed: 10
    };
  },
  mr = function mr(e) {
    return {
      type: "spring",
      stiffness: 550,
      damping: 0 === e ? 2 * Math.sqrt(550) : 30,
      restDelta: .01,
      restSpeed: 10
    };
  },
  hr = function hr() {
    return {
      type: "keyframes",
      ease: "linear",
      duration: .3
    };
  },
  yr = function yr(e) {
    return {
      type: "keyframes",
      duration: .8,
      values: e
    };
  },
  gr = {
    x: vr,
    y: vr,
    z: vr,
    rotate: vr,
    rotateX: vr,
    rotateY: vr,
    rotateZ: vr,
    scaleX: mr,
    scaleY: mr,
    scale: mr,
    opacity: hr,
    backgroundColor: hr,
    color: hr,
    default: mr
  },
  br = _p(_p({}, Be), {
    color: Ie,
    backgroundColor: Ie,
    outlineColor: Ie,
    fill: Ie,
    stroke: Ie,
    borderColor: Ie,
    borderTopColor: Ie,
    borderRightColor: Ie,
    borderBottomColor: Ie,
    borderLeftColor: Ie,
    filter: ze,
    WebkitFilter: ze
  }),
  wr = function wr(e) {
    return br[e];
  };
function xr(e, t) {
  var n,
    r = wr(e);
  return r !== ze && (r = je), null === (n = r.getAnimatableNone) || void 0 === n ? void 0 : n.call(r, t);
}
var Sr = !1;
function Ar(e) {
  var t = e.ease,
    n = e.times,
    r = e.yoyo,
    o = e.flip,
    i = e.loop,
    a = v(e, ["ease", "times", "yoyo", "flip", "loop"]),
    s = _p({}, a);
  return n && (s.offset = n), a.duration && (s.duration = lr(a.duration)), a.repeatDelay && (s.repeatDelay = lr(a.repeatDelay)), t && (s.ease = function (e) {
    return Array.isArray(e) && "number" != typeof e[0];
  }(t) ? t.map(dr) : dr(t)), "tween" === a.type && (s.type = "keyframes"), (r || i || o) && (x(!Sr, "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options."), Sr = !0, r ? s.repeatType = "reverse" : i ? s.repeatType = "loop" : o && (s.repeatType = "mirror"), s.repeat = i || r || o || a.repeat), "spring" !== a.type && (s.type = "keyframes"), s;
}
function kr(e, t, n) {
  var r, o, i, a;
  return Array.isArray(t.to) && (null !== (r = e.duration) && void 0 !== r || (e.duration = .8)), function (e) {
    Array.isArray(e.to) && null === e.to[0] && (e.to = h([], m(e.to)), e.to[0] = e.from);
  }(t), function (e) {
    e.when, e.delay, e.delayChildren, e.staggerChildren, e.staggerDirection, e.repeat, e.repeatType, e.repeatDelay, e.from;
    var t = v(e, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from"]);
    return !!Object.keys(t).length;
  }(e) || (e = _p(_p({}, e), (o = n, i = t.to, a = vt(i) ? yr : gr[o] || gr.default, _p({
    to: i
  }, a(i))))), _p(_p({}, t), Ar(e));
}
function Er(e, t, n, r, o) {
  var i,
    a = Pr(r, e),
    s = null !== (i = a.from) && void 0 !== i ? i : t.get(),
    u = pr(e, n);
  "none" === s && u && "string" == typeof n ? s = xr(e, n) : Cr(s) && "string" == typeof n ? s = Tr(n) : !Array.isArray(n) && Cr(n) && "string" == typeof s && (n = Tr(s));
  var c = pr(e, s);
  return x(c === u, "You are trying to animate " + e + ' from "' + s + '" to "' + n + '". ' + s + " is not an animatable value - to enable this animation set " + s + " to a value animatable to " + n + " via the `style` property."), c && u && !1 !== a.type ? function () {
    var r = {
      from: s,
      to: n,
      velocity: t.getVelocity(),
      onComplete: o,
      onUpdate: function onUpdate(e) {
        return t.set(e);
      }
    };
    return "inertia" === a.type || "decay" === a.type ? function (e) {
      var t,
        n = e.from,
        r = void 0 === n ? 0 : n,
        o = e.velocity,
        i = void 0 === o ? 0 : o,
        a = e.min,
        s = e.max,
        u = e.power,
        c = void 0 === u ? .8 : u,
        l = e.timeConstant,
        f = void 0 === l ? 750 : l,
        d = e.bounceStiffness,
        v = void 0 === d ? 500 : d,
        m = e.bounceDamping,
        h = void 0 === m ? 10 : m,
        y = e.restDelta,
        g = void 0 === y ? 1 : y,
        b = e.modifyTarget,
        w = e.driver,
        x = e.onUpdate,
        S = e.onComplete;
      function A(e) {
        return void 0 !== a && e < a || void 0 !== s && e > s;
      }
      function k(e) {
        return void 0 === a ? s : void 0 === s || Math.abs(a - e) < Math.abs(s - e) ? a : s;
      }
      function E(e) {
        null == t || t.stop(), t = Kn(_p(_p({}, e), {
          driver: w,
          onUpdate: function onUpdate(t) {
            var n;
            null == x || x(t), null === (n = e.onUpdate) || void 0 === n || n.call(e, t);
          },
          onComplete: S
        }));
      }
      function C(e) {
        E(_p({
          type: "spring",
          stiffness: v,
          damping: h,
          restDelta: g
        }, e));
      }
      if (A(r)) C({
        from: r,
        velocity: i,
        to: k(r)
      });else {
        var T = c * i + r;
        void 0 !== b && (T = b(T));
        var P,
          O,
          R = k(T),
          I = R === a ? -1 : 1;
        E({
          type: "decay",
          from: r,
          velocity: i,
          timeConstant: f,
          power: c,
          restDelta: g,
          modifyTarget: b,
          onUpdate: A(T) ? function (e) {
            P = O, O = e, i = Zn(e - P, qn().delta), (1 === I && e > R || -1 === I && e < R) && C({
              from: e,
              to: R,
              velocity: i
            });
          } : void 0
        });
      }
      return {
        stop: function stop() {
          return null == t ? void 0 : t.stop();
        }
      };
    }(_p(_p({}, r), a)) : Kn(_p(_p({}, kr(a, r, e)), {
      onUpdate: function onUpdate(e) {
        var t;
        r.onUpdate(e), null === (t = a.onUpdate) || void 0 === t || t.call(a, e);
      },
      onComplete: function onComplete() {
        var e;
        r.onComplete(), null === (e = a.onComplete) || void 0 === e || e.call(a);
      }
    }));
  } : function () {
    var e;
    return t.set(n), o(), null === (e = null == a ? void 0 : a.onComplete) || void 0 === e || e.call(a), {
      stop: function stop() {}
    };
  };
}
function Cr(e) {
  return 0 === e || "string" == typeof e && 0 === parseFloat(e) && -1 === e.indexOf(" ");
}
function Tr(e) {
  return "number" == typeof e ? 0 : xr("", e);
}
function Pr(e, t) {
  return e[t] || e.default || e;
}
function Or(e, t, n, r) {
  return void 0 === r && (r = {}), t.start(function (o) {
    var i,
      a,
      s = Er(e, t, n, r, o),
      u = function (e, t) {
        var n;
        return null !== (n = (Pr(e, t) || {}).delay) && void 0 !== n ? n : 0;
      }(r, e),
      c = function c() {
        return a = s();
      };
    return u ? i = setTimeout(c, lr(u)) : c(), function () {
      clearTimeout(i), null == a || a.stop();
    };
  });
}
var Rr = function Rr(e) {
  return /^\-?\d*\.?\d+$/.test(e);
};
function Ir(e, t) {
  -1 === e.indexOf(t) && e.push(t);
}
function Mr(e, t) {
  var n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
var Vr = function () {
    function e() {
      this.subscriptions = [];
    }
    return e.prototype.add = function (e) {
      var t = this;
      return Ir(this.subscriptions, e), function () {
        return Mr(t.subscriptions, e);
      };
    }, e.prototype.notify = function (e, t, n) {
      var r = this.subscriptions.length;
      if (r) if (1 === r) this.subscriptions[0](e, t, n);else for (var o = 0; o < r; o++) {
        var i = this.subscriptions[o];
        i && i(e, t, n);
      }
    }, e.prototype.getSize = function () {
      return this.subscriptions.length;
    }, e.prototype.clear = function () {
      this.subscriptions.length = 0;
    }, e;
  }(),
  _r = function () {
    function e(e) {
      var t,
        n = this;
      this.timeDelta = 0, this.lastUpdated = 0, this.updateSubscribers = new Vr(), this.velocityUpdateSubscribers = new Vr(), this.renderSubscribers = new Vr(), this.canTrackVelocity = !1, this.updateAndNotify = function (e, t) {
        void 0 === t && (t = !0), n.prev = n.current, n.current = e;
        var r = qn(),
          o = r.delta,
          i = r.timestamp;
        n.lastUpdated !== i && (n.timeDelta = o, n.lastUpdated = i, Bn.postRender(n.scheduleVelocityCheck)), n.prev !== n.current && n.updateSubscribers.notify(n.current), n.velocityUpdateSubscribers.getSize() && n.velocityUpdateSubscribers.notify(n.getVelocity()), t && n.renderSubscribers.notify(n.current);
      }, this.scheduleVelocityCheck = function () {
        return Bn.postRender(n.velocityCheck);
      }, this.velocityCheck = function (e) {
        e.timestamp !== n.lastUpdated && (n.prev = n.current, n.velocityUpdateSubscribers.notify(n.getVelocity()));
      }, this.hasAnimated = !1, this.prev = this.current = e, this.canTrackVelocity = (t = this.current, !isNaN(parseFloat(t)));
    }
    return e.prototype.onChange = function (e) {
      return this.updateSubscribers.add(e);
    }, e.prototype.clearListeners = function () {
      this.updateSubscribers.clear();
    }, e.prototype.onRenderRequest = function (e) {
      return e(this.get()), this.renderSubscribers.add(e);
    }, e.prototype.attach = function (e) {
      this.passiveEffect = e;
    }, e.prototype.set = function (e, t) {
      void 0 === t && (t = !0), t && this.passiveEffect ? this.passiveEffect(e, this.updateAndNotify) : this.updateAndNotify(e, t);
    }, e.prototype.get = function () {
      return this.current;
    }, e.prototype.getPrevious = function () {
      return this.prev;
    }, e.prototype.getVelocity = function () {
      return this.canTrackVelocity ? Zn(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
    }, e.prototype.start = function (e) {
      var t = this;
      return this.stop(), new Promise(function (n) {
        t.hasAnimated = !0, t.stopAnimation = e(n);
      }).then(function () {
        return t.clearAnimation();
      });
    }, e.prototype.stop = function () {
      this.stopAnimation && this.stopAnimation(), this.clearAnimation();
    }, e.prototype.isAnimating = function () {
      return !!this.stopAnimation;
    }, e.prototype.clearAnimation = function () {
      this.stopAnimation = null;
    }, e.prototype.destroy = function () {
      this.updateSubscribers.clear(), this.renderSubscribers.clear(), this.stop();
    }, e;
  }();
function Nr(e) {
  return new _r(e);
}
var jr = function jr(e) {
    return function (t) {
      return t.test(e);
    };
  },
  $r = [ve, we, be, ge, Se, xe, {
    test: function test(e) {
      return "auto" === e;
    },
    parse: function parse(e) {
      return e;
    }
  }],
  Lr = function Lr(e) {
    return $r.find(jr(e));
  },
  Dr = h(h([], m($r)), [Ie, je]),
  zr = function zr(e) {
    return Dr.find(jr(e));
  };
function Fr(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, Nr(n));
}
function Br(e, t) {
  if (t) return (t[e] || t.default || t).from;
}
function Hr(e, t, n) {
  var r;
  void 0 === n && (n = {});
  var o = F(e, t, n.custom),
    i = (o || {}).transition,
    a = void 0 === i ? e.getDefaultTransition() || {} : i;
  n.transitionOverride && (a = n.transitionOverride);
  var s = o ? function () {
      return Ur(e, o, n);
    } : function () {
      return Promise.resolve();
    },
    u = (null === (r = e.variantChildren) || void 0 === r ? void 0 : r.size) ? function (r) {
      void 0 === r && (r = 0);
      var o = a.delayChildren,
        i = void 0 === o ? 0 : o,
        s = a.staggerChildren,
        u = a.staggerDirection;
      return function (e, t, n, r, o, i) {
        void 0 === n && (n = 0);
        void 0 === r && (r = 0);
        void 0 === o && (o = 1);
        var a = [],
          s = (e.variantChildren.size - 1) * r,
          u = 1 === o ? function (e) {
            return void 0 === e && (e = 0), e * r;
          } : function (e) {
            return void 0 === e && (e = 0), s - e * r;
          };
        return Array.from(e.variantChildren).sort(Yr).forEach(function (e, r) {
          a.push(Hr(e, t, _p(_p({}, i), {
            delay: n + u(r)
          })).then(function () {
            return e.notifyAnimationComplete(t);
          }));
        }), Promise.all(a);
      }(e, t, i + r, s, u, n);
    } : function () {
      return Promise.resolve();
    },
    c = a.when;
  if (c) {
    var l = m("beforeChildren" === c ? [s, u] : [u, s], 2),
      f = l[0],
      d = l[1];
    return f().then(d);
  }
  return Promise.all([s(), u(n.delay)]);
}
function Ur(e, t, n) {
  var r,
    o = void 0 === n ? {} : n,
    i = o.delay,
    a = void 0 === i ? 0 : i,
    s = o.transitionOverride,
    u = o.type,
    c = e.makeTargetAnimatable(t),
    l = c.transition,
    f = void 0 === l ? e.getDefaultTransition() : l,
    d = c.transitionEnd,
    m = v(c, ["transition", "transitionEnd"]);
  s && (f = s);
  var h = [],
    y = u && (null === (r = e.animationState) || void 0 === r ? void 0 : r.getState()[u]);
  for (var g in m) {
    var b = e.getValue(g),
      w = m[g];
    if (!(!b || void 0 === w || y && Xr(y, g))) {
      var x = Or(g, b, w, _p({
        delay: a
      }, f));
      h.push(x);
    }
  }
  return Promise.all(h).then(function () {
    d && function (e, t) {
      var n = F(e, t),
        r = n ? e.makeTargetAnimatable(n, !1) : {},
        o = r.transitionEnd,
        i = void 0 === o ? {} : o;
      r.transition;
      var a = v(r, ["transitionEnd", "transition"]);
      for (var s in a = _p(_p({}, a), i)) Fr(e, s, mt(a[s]));
    }(e, d);
  });
}
function Yr(e, t) {
  return e.sortNodePosition(t);
}
function Xr(e, t) {
  var n = e.protectedKeys,
    r = e.needsAnimating,
    o = n.hasOwnProperty(t) && !0 !== r[t];
  return r[t] = !1, o;
}
var qr = [xt.Animate, xt.Hover, xt.Tap, xt.Drag, xt.Focus, xt.Exit],
  Wr = h([], m(qr)).reverse(),
  Gr = qr.length;
function Kr(e) {
  return function (t) {
    return Promise.all(t.map(function (t) {
      var n = t.animation,
        r = t.options;
      return function (e, t, n) {
        var r;
        if (void 0 === n && (n = {}), e.notifyAnimationStart(), Array.isArray(t)) {
          var o = t.map(function (t) {
            return Hr(e, t, n);
          });
          r = Promise.all(o);
        } else if ("string" == typeof t) r = Hr(e, t, n);else {
          var i = "function" == typeof t ? F(e, t, n.custom) : t;
          r = Ur(e, i, n);
        }
        return r.then(function () {
          return e.notifyAnimationComplete(t);
        });
      }(e, n, r);
    }));
  };
}
function Zr(e) {
  var t,
    n = Kr(e),
    r = ((t = {})[xt.Animate] = Jr(!0), t[xt.Hover] = Jr(), t[xt.Tap] = Jr(), t[xt.Drag] = Jr(), t[xt.Focus] = Jr(), t[xt.Exit] = Jr(), t),
    o = {},
    i = !0,
    a = function a(t, n) {
      var r = F(e, n);
      if (r) {
        r.transition;
        var o = r.transitionEnd,
          i = v(r, ["transition", "transitionEnd"]);
        t = _p(_p(_p({}, t), i), o);
      }
      return t;
    };
  function s(t, s) {
    for (var u, c = e.getProps(), l = e.getVariantContext(!0) || {}, f = [], d = new Set(), v = {}, y = 1 / 0, g = function g(n) {
        var o = Wr[n],
          g = r[o],
          b = null !== (u = c[o]) && void 0 !== u ? u : l[o],
          w = D(b),
          x = o === s ? g.isActive : null;
        !1 === x && (y = n);
        var S = b === l[o] && b !== c[o] && w;
        if (S && i && e.manuallyAnimateOnMount && (S = !1), g.protectedKeys = _p({}, v), !g.isActive && null === x || !b && !g.prevProp || pt(b) || "boolean" == typeof b) return "continue";
        var A = function (e, t) {
            if ("string" == typeof t) return t !== e;
            if (L(t)) return !cr(t, e);
            return !1;
          }(g.prevProp, b) || o === s && g.isActive && !S && w || n > y && w,
          k = Array.isArray(b) ? b : [b],
          E = k.reduce(a, {});
        !1 === x && (E = {});
        var C = g.prevResolvedValues,
          T = void 0 === C ? {} : C,
          P = _p(_p({}, T), E),
          O = function O(e) {
            A = !0, d.delete(e), g.needsAnimating[e] = !0;
          };
        for (var R in P) {
          var I = E[R],
            M = T[R];
          v.hasOwnProperty(R) || (I !== M ? vt(I) && vt(M) ? cr(I, M) ? g.protectedKeys[R] = !0 : O(R) : void 0 !== I ? O(R) : d.add(R) : void 0 !== I && d.has(R) ? O(R) : g.protectedKeys[R] = !0);
        }
        g.prevProp = b, g.prevResolvedValues = E, g.isActive && (v = _p(_p({}, v), E)), i && e.blockInitialAnimation && (A = !1), A && !S && f.push.apply(f, h([], m(k.map(function (e) {
          return {
            animation: e,
            options: _p({
              type: o
            }, t)
          };
        }))));
      }, b = 0; b < Gr; b++) g(b);
    if (o = _p({}, v), d.size) {
      var w = {};
      d.forEach(function (t) {
        var n = e.getBaseTarget(t);
        void 0 !== n && (w[t] = n);
      }), f.push({
        animation: w
      });
    }
    var x = Boolean(f.length);
    return i && !1 === c.initial && !e.manuallyAnimateOnMount && (x = !1), i = !1, x ? n(f) : Promise.resolve();
  }
  return {
    isAnimated: function isAnimated(e) {
      return void 0 !== o[e];
    },
    animateChanges: s,
    setActive: function setActive(t, n, o) {
      var i;
      return r[t].isActive === n ? Promise.resolve() : (null === (i = e.variantChildren) || void 0 === i || i.forEach(function (e) {
        var r;
        return null === (r = e.animationState) || void 0 === r ? void 0 : r.setActive(t, n);
      }), r[t].isActive = n, s(o, t));
    },
    setAnimateFunction: function setAnimateFunction(t) {
      n = t(e);
    },
    getState: function getState() {
      return r;
    }
  };
}
function Jr(e) {
  return void 0 === e && (e = !1), {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
var Qr = {
  animation: sr(function (e) {
    var t = e.visualElement,
      n = e.animate;
    t.animationState || (t.animationState = Zr(t)), pt(n) && i(function () {
      return n.subscribe(t);
    }, [n]);
  }),
  exit: sr(function (e) {
    var t = e.custom,
      n = e.visualElement,
      o = m(function () {
        var e = r(P);
        if (null === e) return [!0, null];
        var t = e.isPresent,
          n = e.onExitComplete,
          o = e.register,
          a = M();
        return i(function () {
          return o(a);
        }, []), !t && n ? [!1, function () {
          return null == n ? void 0 : n(a);
        }] : [!0];
      }(), 2),
      a = o[0],
      s = o[1],
      u = r(P);
    i(function () {
      var e,
        r,
        o = null === (e = n.animationState) || void 0 === e ? void 0 : e.setActive(xt.Exit, !a, {
          custom: null !== (r = null == u ? void 0 : u.custom) && void 0 !== r ? r : t
        });
      !a && (null == o || o.then(s));
    }, [a]);
  })
};
function eo(e) {
  return e;
}
var to = {
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
};
function no() {
  return {
    x: _p({}, to),
    y: _p({}, to)
  };
}
function ro(e) {
  return [e("x"), e("y")];
}
function oo(e, t) {
  var n,
    r,
    o = e.getBoundingClientRect();
  return n = function (e, t) {
    var n = e.top,
      r = e.left,
      o = e.bottom,
      i = e.right;
    void 0 === t && (t = eo);
    var a = t({
        x: r,
        y: n
      }),
      s = t({
        x: i,
        y: o
      });
    return {
      top: a.y,
      left: a.x,
      bottom: s.y,
      right: s.x
    };
  }(o, t), r = n.top, {
    x: {
      min: n.left,
      max: n.right
    },
    y: {
      min: r,
      max: n.bottom
    }
  };
}
function io(e, t, n) {
  return void 0 === t && (t = 0), void 0 === n && (n = .01), function (e, t) {
    if (nn(e) && nn(t)) return er(e, t);
    if (Jn(e) && Jn(t)) {
      var n = er(e.x, t.x),
        r = er(e.y, t.y),
        o = Qn(e) && Qn(t) ? er(e.z, t.z) : 0;
      return Math.sqrt(Math.pow(n, 2) + Math.pow(r, 2) + Math.pow(o, 2));
    }
  }(e, t) < n;
}
function ao(e) {
  return e.max - e.min;
}
function so(e, t, n, r) {
  void 0 === r && (r = .5), e.origin = r, e.originPoint = Kt(t.min, t.max, e.origin), e.scale = ao(n) / ao(t), io(e.scale, 1, 1e-4) && (e.scale = 1), e.translate = Kt(n.min, n.max, e.origin) - e.originPoint, io(e.translate) && (e.translate = 0);
}
function uo(e, t, n, r) {
  so(e.x, t.x, n.x, co(r.originX)), so(e.y, t.y, n.y, co(r.originY));
}
function co(e) {
  return "number" == typeof e ? e : .5;
}
function lo(e, t, n) {
  e.min = n.min + t.min, e.max = e.min + ao(t);
}
var fo = function fo(e, t) {
  return e.depth - t.depth;
};
function po(e, t) {
  return {
    min: t.min - e.min,
    max: t.max - e.min
  };
}
function vo(e) {
  var t = e.getProps(),
    n = t.drag,
    r = t._dragX;
  return n && !r;
}
function mo(e, t) {
  e.min = t.min, e.max = t.max;
}
function ho(e, t, n) {
  return n + t * (e - n);
}
function yo(e, t, n, r, o) {
  return void 0 !== o && (e = ho(e, o, r)), ho(e, n, r) + t;
}
function go(e, t, n, r, o) {
  void 0 === t && (t = 0), void 0 === n && (n = 1), e.min = yo(e.min, t, n, r, o), e.max = yo(e.max, t, n, r, o);
}
function bo(e, t) {
  var n = t.x,
    r = t.y;
  go(e.x, n.translate, n.scale, n.originPoint), go(e.y, r.translate, r.scale, r.originPoint);
}
function wo(e, t, n, r) {
  var o = m(r, 3),
    i = o[0],
    a = o[1],
    s = o[2];
  e.min = t.min, e.max = t.max;
  var u = void 0 !== n[s] ? n[s] : .5,
    c = Kt(t.min, t.max, u);
  go(e, n[i], n[a], c, n.scale);
}
var xo,
  So,
  Ao = ["x", "scaleX", "originX"],
  ko = ["y", "scaleY", "originY"];
function Eo(e, t, n) {
  wo(e.x, t.x, n, Ao), wo(e.y, t.y, n, ko);
}
function Co(e, t, n, r, o) {
  return e = ho(e -= t, 1 / n, r), void 0 !== o && (e = ho(e, 1 / o, r)), e;
}
function To(e, t, n) {
  var r = m(n, 3),
    o = r[0],
    i = r[1],
    a = r[2];
  !function (e, t, n, r, o) {
    void 0 === t && (t = 0), void 0 === n && (n = 1), void 0 === r && (r = .5);
    var i = Kt(e.min, e.max, r) - t;
    e.min = Co(e.min, t, n, i, o), e.max = Co(e.max, t, n, i, o);
  }(e, t[o], t[i], t[a], t.scale);
}
function Po(e) {
  return "string" == typeof e && e.startsWith("var(--");
}
!function (e) {
  e[e.Entering = 0] = "Entering", e[e.Present = 1] = "Present", e[e.Exiting = 2] = "Exiting";
}(xo || (xo = {})), function (e) {
  e[e.Hide = 0] = "Hide", e[e.Show = 1] = "Show";
}(So || (So = {}));
var Oo = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function Ro(e, t, n) {
  void 0 === n && (n = 1), S(n <= 4, 'Max CSS variable fallback depth detected in property "' + e + '". This may indicate a circular fallback dependency.');
  var r = m(function (e) {
      var t = Oo.exec(e);
      if (!t) return [,];
      var n = m(t, 3);
      return [n[1], n[2]];
    }(e), 2),
    o = r[0],
    i = r[1];
  if (o) {
    var a = window.getComputedStyle(t).getPropertyValue(o);
    return a ? a.trim() : Po(i) ? Ro(i, t, n + 1) : i;
  }
}
function Io() {
  return {
    isHydrated: !1,
    layout: {
      x: {
        min: 0,
        max: 1
      },
      y: {
        min: 0,
        max: 1
      }
    },
    layoutCorrected: {
      x: {
        min: 0,
        max: 1
      },
      y: {
        min: 0,
        max: 1
      }
    },
    treeScale: {
      x: 1,
      y: 1
    },
    delta: no(),
    deltaFinal: no(),
    deltaTransform: ""
  };
}
var Mo = Io();
function Vo(e, t, n) {
  var r = e.x,
    o = e.y,
    i = "translate3d(" + r.translate / t.x + "px, " + o.translate / t.y + "px, 0) ";
  if (n) {
    var a = n.rotate,
      s = n.rotateX,
      u = n.rotateY;
    a && (i += "rotate(" + a + ") "), s && (i += "rotateX(" + s + ") "), u && (i += "rotateY(" + u + ") ");
  }
  return i += "scale(" + r.scale + ", " + o.scale + ")", n || i !== No ? i : "";
}
function _o(e) {
  var t = e.deltaFinal;
  return 100 * t.x.origin + "% " + 100 * t.y.origin + "% 0";
}
var No = Vo(Mo.delta, Mo.treeScale, {
    x: 1,
    y: 1
  }),
  jo = ["LayoutMeasure", "BeforeLayoutMeasure", "LayoutUpdate", "ViewportBoxUpdate", "Update", "Render", "AnimationComplete", "LayoutAnimationComplete", "AnimationStart", "SetAxisTarget", "Unmount"];
function $o(e, t, n, r) {
  var o,
    i,
    a = e.delta,
    s = e.layout,
    u = e.layoutCorrected,
    c = e.treeScale,
    l = t.target;
  i = s, mo((o = u).x, i.x), mo(o.y, i.y), function (e, t, n) {
    var r = n.length;
    if (r) {
      var o, i;
      t.x = t.y = 1;
      for (var a = 0; a < r; a++) i = (o = n[a]).getLayoutState().delta, t.x *= i.x.scale, t.y *= i.y.scale, bo(e, i), vo(o) && Eo(e, e, o.getLatestValues());
    }
  }(u, c, n), uo(a, u, l, r);
}
var Lo = function () {
  function e() {
    this.children = [], this.isDirty = !1;
  }
  return e.prototype.add = function (e) {
    Ir(this.children, e), this.isDirty = !0;
  }, e.prototype.remove = function (e) {
    Mr(this.children, e), this.isDirty = !0;
  }, e.prototype.forEach = function (e) {
    this.isDirty && this.children.sort(fo), this.isDirty = !1, this.children.forEach(e);
  }, e;
}();
function Do(e) {
  var t = e.getProjectionParent();
  if (t) {
    var n,
      r,
      o = (n = t.getLayoutState().layout, r = e.getLayoutState().layout, {
        x: po(n.x, r.x),
        y: po(n.y, r.y)
      });
    ro(function (t) {
      e.setProjectionTargetAxis(t, o[t].min, o[t].max, !0);
    });
  } else e.rebaseProjectionTarget();
}
var zo = function zo(e) {
  var t = e.treeType,
    n = void 0 === t ? "" : t,
    r = e.build,
    o = e.getBaseTarget,
    i = e.makeTargetAnimatable,
    a = e.measureViewportBox,
    s = e.render,
    u = e.readValueFromInstance,
    c = e.resetTransform,
    l = e.restoreTransform,
    f = e.removeValueFromRenderState,
    d = e.sortNodePosition,
    v = e.scrapeMotionValuesFromProps;
  return function (e, t) {
    var y = e.parent,
      g = e.props,
      b = e.presenceId,
      w = e.blockInitialAnimation,
      x = e.visualState;
    void 0 === t && (t = {});
    var S,
      A,
      k,
      E,
      C,
      T,
      P = x.latestValues,
      O = x.renderState,
      R = function () {
        var e = jo.map(function () {
            return new Vr();
          }),
          t = {},
          n = {
            clearAllListeners: function clearAllListeners() {
              return e.forEach(function (e) {
                return e.clear();
              });
            },
            updatePropListeners: function updatePropListeners(e) {
              return jo.forEach(function (r) {
                var o;
                null === (o = t[r]) || void 0 === o || o.call(t);
                var i = "on" + r,
                  a = e[i];
                a && (t[r] = n[i](a));
              });
            }
          };
        return e.forEach(function (e, t) {
          n["on" + jo[t]] = function (t) {
            return e.add(t);
          }, n["notify" + jo[t]] = function () {
            for (var t = [], n = 0; n < arguments.length; n++) t[n] = arguments[n];
            return e.notify.apply(e, h([], m(t)));
          };
        }), n;
      }(),
      I = {
        isEnabled: !1,
        isHydrated: !1,
        isTargetLocked: !1,
        target: {
          x: {
            min: 0,
            max: 1
          },
          y: {
            min: 0,
            max: 1
          }
        },
        targetFinal: {
          x: {
            min: 0,
            max: 1
          },
          y: {
            min: 0,
            max: 1
          }
        }
      },
      M = I,
      V = P,
      _ = Io(),
      N = !1,
      j = new Map(),
      $ = new Map(),
      L = {},
      z = _p({}, P);
    function F() {
      S && (J.isProjectionReady() && (Eo(M.targetFinal, M.target, V), uo(_.deltaFinal, _.layoutCorrected, M.targetFinal, P)), U(), s(S, O));
    }
    function U() {
      var e = P;
      if (E && E.isActive()) {
        var n = E.getCrossfadeState(J);
        n && (e = n);
      }
      r(J, O, e, M, _, t, g);
    }
    function Y() {
      R.notifyUpdate(P);
    }
    function X() {
      J.layoutTree.forEach(Bo);
    }
    var q = v(g);
    for (var W in q) {
      var G = q[W];
      void 0 !== P[W] && oe(G) && G.set(P[W], !1);
    }
    var K = B(g),
      Z = H(g),
      J = _p(_p({
        treeType: n,
        current: null,
        depth: y ? y.depth + 1 : 0,
        parent: y,
        children: new Set(),
        path: y ? h(h([], m(y.path)), [y]) : [],
        layoutTree: y ? y.layoutTree : new Lo(),
        presenceId: b,
        projection: I,
        variantChildren: Z ? new Set() : void 0,
        isVisible: void 0,
        manuallyAnimateOnMount: Boolean(null == y ? void 0 : y.isMounted()),
        blockInitialAnimation: w,
        isMounted: function isMounted() {
          return Boolean(S);
        },
        mount: function mount(e) {
          S = J.current = e, J.pointTo(J), Z && y && !K && (T = null == y ? void 0 : y.addVariantChild(J)), null == y || y.children.add(J);
        },
        unmount: function unmount() {
          Hn.update(Y), Hn.render(F), Hn.preRender(J.updateLayoutProjection), $.forEach(function (e) {
            return e();
          }), J.stopLayoutAnimation(), J.layoutTree.remove(J), null == T || T(), null == y || y.children.delete(J), null == k || k(), R.clearAllListeners();
        },
        addVariantChild: function addVariantChild(e) {
          var t,
            n = J.getClosestVariantNode();
          if (n) return null === (t = n.variantChildren) || void 0 === t || t.add(e), function () {
            return n.variantChildren.delete(e);
          };
        },
        sortNodePosition: function sortNodePosition(e) {
          return d && n === e.treeType ? d(J.getInstance(), e.getInstance()) : 0;
        },
        getClosestVariantNode: function getClosestVariantNode() {
          return Z ? J : null == y ? void 0 : y.getClosestVariantNode();
        },
        scheduleUpdateLayoutProjection: y ? y.scheduleUpdateLayoutProjection : function () {
          return Bn.preRender(J.updateTreeLayoutProjection, !1, !0);
        },
        getLayoutId: function getLayoutId() {
          return g.layoutId;
        },
        getInstance: function getInstance() {
          return S;
        },
        getStaticValue: function getStaticValue(e) {
          return P[e];
        },
        setStaticValue: function setStaticValue(e, t) {
          return P[e] = t;
        },
        getLatestValues: function getLatestValues() {
          return P;
        },
        setVisibility: function setVisibility(e) {
          J.isVisible !== e && (J.isVisible = e, J.scheduleRender());
        },
        makeTargetAnimatable: function makeTargetAnimatable(e, t) {
          return void 0 === t && (t = !0), i(J, e, g, t);
        },
        addValue: function addValue(e, t) {
          J.hasValue(e) && J.removeValue(e), j.set(e, t), P[e] = t.get(), function (e, t) {
            var n = t.onChange(function (t) {
                P[e] = t, g.onUpdate && Bn.update(Y, !1, !0);
              }),
              r = t.onRenderRequest(J.scheduleRender);
            $.set(e, function () {
              n(), r();
            });
          }(e, t);
        },
        removeValue: function removeValue(e) {
          var t;
          j.delete(e), null === (t = $.get(e)) || void 0 === t || t(), $.delete(e), delete P[e], f(e, O);
        },
        hasValue: function hasValue(e) {
          return j.has(e);
        },
        getValue: function getValue(e, t) {
          var n = j.get(e);
          return void 0 === n && void 0 !== t && (n = Nr(t), J.addValue(e, n)), n;
        },
        forEachValue: function forEachValue(e) {
          return j.forEach(e);
        },
        readValue: function readValue(e) {
          var n;
          return null !== (n = P[e]) && void 0 !== n ? n : u(S, e, t);
        },
        setBaseTarget: function setBaseTarget(e, t) {
          z[e] = t;
        },
        getBaseTarget: function getBaseTarget(e) {
          if (o) {
            var t = o(g, e);
            if (void 0 !== t && !oe(t)) return t;
          }
          return z[e];
        }
      }, R), {
        build: function build() {
          return U(), O;
        },
        scheduleRender: function scheduleRender() {
          Bn.render(F, !1, !0);
        },
        syncRender: F,
        setProps: function setProps(e) {
          g = e, R.updatePropListeners(e), L = function (e, t, n) {
            var r;
            for (var o in t) {
              var i = t[o],
                a = n[o];
              if (oe(i)) e.addValue(o, i);else if (oe(a)) e.addValue(o, Nr(i));else if (a !== i) if (e.hasValue(o)) {
                var s = e.getValue(o);
                !s.hasAnimated && s.set(i);
              } else e.addValue(o, Nr(null !== (r = e.getStaticValue(o)) && void 0 !== r ? r : i));
            }
            for (var o in n) void 0 === t[o] && e.removeValue(o);
            return t;
          }(J, v(g), L);
        },
        getProps: function getProps() {
          return g;
        },
        getVariant: function getVariant(e) {
          var t;
          return null === (t = g.variants) || void 0 === t ? void 0 : t[e];
        },
        getDefaultTransition: function getDefaultTransition() {
          return g.transition;
        },
        getVariantContext: function getVariantContext(e) {
          if (void 0 === e && (e = !1), e) return null == y ? void 0 : y.getVariantContext();
          if (!K) {
            var t = (null == y ? void 0 : y.getVariantContext()) || {};
            return void 0 !== g.initial && (t.initial = g.initial), t;
          }
          for (var n = {}, r = 0; r < Yo; r++) {
            var o = Uo[r],
              i = g[o];
            (D(i) || !1 === i) && (n[o] = i);
          }
          return n;
        },
        enableLayoutProjection: function enableLayoutProjection() {
          I.isEnabled = !0, J.layoutTree.add(J);
        },
        lockProjectionTarget: function lockProjectionTarget() {
          I.isTargetLocked = !0;
        },
        unlockProjectionTarget: function unlockProjectionTarget() {
          J.stopLayoutAnimation(), I.isTargetLocked = !1;
        },
        getLayoutState: function getLayoutState() {
          return _;
        },
        setCrossfader: function setCrossfader(e) {
          E = e;
        },
        isProjectionReady: function isProjectionReady() {
          return I.isEnabled && I.isHydrated && _.isHydrated;
        },
        startLayoutAnimation: function startLayoutAnimation(e, t, n) {
          void 0 === n && (n = !1);
          var r = J.getProjectionAnimationProgress()[e],
            o = n ? I.relativeTarget[e] : I.target[e],
            i = o.min,
            a = o.max - i;
          return r.clearListeners(), r.set(i), r.set(i), r.onChange(function (t) {
            J.setProjectionTargetAxis(e, t, t + a, n);
          }), J.animateMotionValue(e, r, 0, t);
        },
        stopLayoutAnimation: function stopLayoutAnimation() {
          ro(function (e) {
            return J.getProjectionAnimationProgress()[e].stop();
          });
        },
        measureViewportBox: function measureViewportBox(e) {
          void 0 === e && (e = !0);
          var n,
            r,
            o = a(S, t);
          return e || (r = P, To((n = o).x, r, Ao), To(n.y, r, ko)), o;
        },
        getProjectionAnimationProgress: function getProjectionAnimationProgress() {
          return C || (C = {
            x: Nr(0),
            y: Nr(0)
          }), C;
        },
        setProjectionTargetAxis: function setProjectionTargetAxis(e, t, n, r) {
          var o;
          void 0 === r && (r = !1), r ? (I.relativeTarget || (I.relativeTarget = {
            x: {
              min: 0,
              max: 1
            },
            y: {
              min: 0,
              max: 1
            }
          }), o = I.relativeTarget[e]) : (I.relativeTarget = void 0, o = I.target[e]), I.isHydrated = !0, o.min = t, o.max = n, N = !0, R.notifySetAxisTarget();
        },
        rebaseProjectionTarget: function rebaseProjectionTarget(e, t) {
          void 0 === t && (t = _.layout);
          var n = J.getProjectionAnimationProgress(),
            r = n.x,
            o = n.y,
            i = !(I.relativeTarget || I.isTargetLocked || r.isAnimating() || o.isAnimating());
          (e || i) && ro(function (e) {
            var n = t[e],
              r = n.min,
              o = n.max;
            J.setProjectionTargetAxis(e, r, o);
          });
        },
        notifyLayoutReady: function notifyLayoutReady(e) {
          Do(J), J.notifyLayoutUpdate(_.layout, J.prevViewportBox || _.layout, e);
        },
        resetTransform: function resetTransform() {
          return c(J, S, g);
        },
        restoreTransform: function restoreTransform() {
          return l(S, O);
        },
        updateLayoutProjection: function updateLayoutProjection() {
          if (J.isProjectionReady()) {
            var e = _.delta,
              t = _.treeScale,
              n = t.x,
              r = t.y,
              o = _.deltaTransform;
            $o(_, M, J.path, P), N && J.notifyViewportBoxUpdate(M.target, e), N = !1;
            var i = Vo(e, t);
            i === o && n === t.x && r === t.y || J.scheduleRender(), _.deltaTransform = i;
          }
        },
        updateTreeLayoutProjection: function updateTreeLayoutProjection() {
          J.layoutTree.forEach(Fo), Bn.preRender(X, !1, !0);
        },
        getProjectionParent: function getProjectionParent() {
          if (void 0 === A) {
            for (var e = !1, t = J.path.length - 1; t >= 0; t--) {
              var n = J.path[t];
              if (n.projection.isEnabled) {
                e = n;
                break;
              }
            }
            A = e;
          }
          return A;
        },
        resolveRelativeTargetBox: function resolveRelativeTargetBox() {
          var e = J.getProjectionParent();
          if (I.relativeTarget && e && (function (e, t) {
            lo(e.target.x, e.relativeTarget.x, t.target.x), lo(e.target.y, e.relativeTarget.y, t.target.y);
          }(I, e.projection), vo(e))) {
            var t = I.target;
            Eo(t, t, e.getLatestValues());
          }
        },
        shouldResetTransform: function shouldResetTransform() {
          return Boolean(g._layoutResetTransform);
        },
        pointTo: function pointTo(e) {
          M = e.projection, V = e.getLatestValues(), null == k || k(), k = on(e.onSetAxisTarget(J.scheduleUpdateLayoutProjection), e.onLayoutAnimationComplete(function () {
            var e;
            J.isPresent ? J.presence = xo.Present : null === (e = J.layoutSafeToRemove) || void 0 === e || e.call(J);
          }));
        },
        isPresent: !0,
        presence: xo.Entering
      });
    return J;
  };
};
function Fo(e) {
  e.resolveRelativeTargetBox();
}
function Bo(e) {
  e.updateLayoutProjection();
}
var Ho,
  Uo = h(["initial"], m(qr)),
  Yo = Uo.length,
  Xo = new Set(["width", "height", "top", "left", "right", "bottom", "x", "y"]),
  qo = function qo(e) {
    return Xo.has(e);
  },
  Wo = function Wo(e, t) {
    e.set(t, !1), e.set(t);
  },
  Go = function Go(e) {
    return e === ve || e === we;
  };
!function (e) {
  e.width = "width", e.height = "height", e.left = "left", e.right = "right", e.top = "top", e.bottom = "bottom";
}(Ho || (Ho = {}));
var Ko = function Ko(e, t) {
    return parseFloat(e.split(", ")[t]);
  },
  Zo = function Zo(e, t) {
    return function (n, r) {
      var o = r.transform;
      if ("none" === o || !o) return 0;
      var i = o.match(/^matrix3d\((.+)\)$/);
      if (i) return Ko(i[1], t);
      var a = o.match(/^matrix\((.+)\)$/);
      return a ? Ko(a[1], e) : 0;
    };
  },
  Jo = new Set(["x", "y", "z"]),
  Qo = Z.filter(function (e) {
    return !Jo.has(e);
  });
var ei = {
    width: function width(e) {
      var t = e.x;
      return t.max - t.min;
    },
    height: function height(e) {
      var t = e.y;
      return t.max - t.min;
    },
    top: function top(e, t) {
      var n = t.top;
      return parseFloat(n);
    },
    left: function left(e, t) {
      var n = t.left;
      return parseFloat(n);
    },
    bottom: function bottom(e, t) {
      var n = e.y,
        r = t.top;
      return parseFloat(r) + (n.max - n.min);
    },
    right: function right(e, t) {
      var n = e.x,
        r = t.left;
      return parseFloat(r) + (n.max - n.min);
    },
    x: Zo(4, 13),
    y: Zo(5, 14)
  },
  ti = function ti(e, t, n, r) {
    void 0 === n && (n = {}), void 0 === r && (r = {}), t = _p({}, t), r = _p({}, r);
    var o = Object.keys(t).filter(qo),
      i = [],
      a = !1,
      s = [];
    if (o.forEach(function (o) {
      var u = e.getValue(o);
      if (e.hasValue(o)) {
        var c,
          l = n[o],
          f = t[o],
          d = Lr(l);
        if (vt(f)) for (var p = f.length, v = null === f[0] ? 1 : 0; v < p; v++) c ? S(Lr(f[v]) === c, "All keyframes must be of the same type") : (c = Lr(f[v]), S(c === d || Go(d) && Go(c), "Keyframes must be of the same dimension as the current value"));else c = Lr(f);
        if (d !== c) if (Go(d) && Go(c)) {
          var m = u.get();
          "string" == typeof m && u.set(parseFloat(m)), "string" == typeof f ? t[o] = parseFloat(f) : Array.isArray(f) && c === we && (t[o] = f.map(parseFloat));
        } else (null == d ? void 0 : d.transform) && (null == c ? void 0 : c.transform) && (0 === l || 0 === f) ? 0 === l ? u.set(c.transform(l)) : t[o] = d.transform(f) : (a || (i = function (e) {
          var t = [];
          return Qo.forEach(function (n) {
            var r = e.getValue(n);
            void 0 !== r && (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
          }), t.length && e.syncRender(), t;
        }(e), a = !0), s.push(o), r[o] = void 0 !== r[o] ? r[o] : t[o], Wo(u, f));
      }
    }), s.length) {
      var u = function (e, t, n) {
        var r = t.measureViewportBox(),
          o = t.getInstance(),
          i = getComputedStyle(o),
          a = i.display,
          s = {
            top: i.top,
            left: i.left,
            bottom: i.bottom,
            right: i.right,
            transform: i.transform
          };
        "none" === a && t.setStaticValue("display", e.display || "block"), t.syncRender();
        var u = t.measureViewportBox();
        return n.forEach(function (n) {
          var o = t.getValue(n);
          Wo(o, ei[n](r, s)), e[n] = ei[n](u, i);
        }), e;
      }(t, e, s);
      return i.length && i.forEach(function (t) {
        var n = m(t, 2),
          r = n[0],
          o = n[1];
        e.getValue(r).set(o);
      }), e.syncRender(), {
        target: u,
        transitionEnd: r
      };
    }
    return {
      target: t,
      transitionEnd: r
    };
  };
function ni(e, t, n, r) {
  return function (e) {
    return Object.keys(e).some(qo);
  }(t) ? ti(e, t, n, r) : {
    target: t,
    transitionEnd: r
  };
}
var ri = function ri(e, t, n, r) {
  var o = function (e, t, n) {
    var r,
      o = v(t, []),
      i = e.getInstance();
    if (!(i instanceof HTMLElement)) return {
      target: o,
      transitionEnd: n
    };
    for (var a in n && (n = _p({}, n)), e.forEachValue(function (e) {
      var t = e.get();
      if (Po(t)) {
        var n = Ro(t, i);
        n && e.set(n);
      }
    }), o) {
      var s = o[a];
      if (Po(s)) {
        var u = Ro(s, i);
        u && (o[a] = u, n && (null !== (r = n[a]) && void 0 !== r || (n[a] = s)));
      }
    }
    return {
      target: o,
      transitionEnd: n
    };
  }(e, t, r);
  return ni(e, t = o.target, n, r = o.transitionEnd);
};
var oi = {
    treeType: "dom",
    readValueFromInstance: function readValueFromInstance(e, t) {
      if (ee(t)) {
        var n = wr(t);
        return n && n.default || 0;
      }
      var r,
        o = (r = e, window.getComputedStyle(r));
      return (ae(t) ? o.getPropertyValue(t) : o[t]) || 0;
    },
    sortNodePosition: function sortNodePosition(e, t) {
      return 2 & e.compareDocumentPosition(t) ? 1 : -1;
    },
    getBaseTarget: function getBaseTarget(e, t) {
      var n;
      return null === (n = e.style) || void 0 === n ? void 0 : n[t];
    },
    measureViewportBox: function measureViewportBox(e, t) {
      return oo(e, t.transformPagePoint);
    },
    resetTransform: function resetTransform(e, t, n) {
      var r = n.transformTemplate;
      t.style.transform = r ? r({}, "") : "none", e.scheduleRender();
    },
    restoreTransform: function restoreTransform(e, t) {
      e.style.transform = t.style.transform;
    },
    removeValueFromRenderState: function removeValueFromRenderState(e, t) {
      var n = t.vars,
        r = t.style;
      delete n[e], delete r[e];
    },
    makeTargetAnimatable: function makeTargetAnimatable(e, t, n, r) {
      var o = n.transformValues;
      void 0 === r && (r = !0);
      var i = t.transition,
        a = t.transitionEnd,
        s = v(t, ["transition", "transitionEnd"]),
        u = function (e, t, n) {
          var r,
            o,
            i = {};
          for (var a in e) i[a] = null !== (r = Br(a, t)) && void 0 !== r ? r : null === (o = n.getValue(a)) || void 0 === o ? void 0 : o.get();
          return i;
        }(s, i || {}, e);
      if (o && (a && (a = o(a)), s && (s = o(s)), u && (u = o(u))), r) {
        !function (e, t, n) {
          var r,
            o,
            i,
            a,
            s = Object.keys(t).filter(function (t) {
              return !e.hasValue(t);
            }),
            u = s.length;
          if (u) for (var c = 0; c < u; c++) {
            var l = s[c],
              f = t[l],
              d = null;
            Array.isArray(f) && (d = f[0]), null === d && (d = null !== (o = null !== (r = n[l]) && void 0 !== r ? r : e.readValue(l)) && void 0 !== o ? o : t[l]), null != d && ("string" == typeof d && Rr(d) ? d = parseFloat(d) : !zr(d) && je.test(f) && (d = xr(l, f)), e.addValue(l, Nr(d)), null !== (i = (a = n)[l]) && void 0 !== i || (a[l] = d), e.setBaseTarget(l, d));
          }
        }(e, s, u);
        var c = ri(e, s, u, a);
        a = c.transitionEnd, s = c.target;
      }
      return _p({
        transition: i,
        transitionEnd: a
      }, s);
    },
    scrapeMotionValuesFromProps: ft,
    build: function build(e, t, n, r, o, i, a) {
      void 0 !== e.isVisible && (t.style.visibility = e.isVisible ? "visible" : "hidden");
      var s = r.isEnabled && o.isHydrated;
      He(t, n, r, o, i, a.transformTemplate, s ? Vo : void 0, s ? _o : void 0);
    },
    render: ut
  },
  ii = zo(oi),
  ai = zo(_p(_p({}, oi), {
    getBaseTarget: function getBaseTarget(e, t) {
      return e[t];
    },
    readValueFromInstance: function readValueFromInstance(e, t) {
      var n;
      return ee(t) ? (null === (n = wr(t)) || void 0 === n ? void 0 : n.default) || 0 : (t = ct.has(t) ? t : st(t), e.getAttribute(t));
    },
    scrapeMotionValuesFromProps: dt,
    build: function build(e, t, n, r, o, i, a) {
      var s = r.isEnabled && o.isHydrated;
      nt(t, n, r, o, i, a.transformTemplate, s ? Vo : void 0, s ? _o : void 0);
    },
    render: lt
  })),
  si = function (e) {
    function t(t, n) {
      return void 0 === n && (n = {}), X(e(t, n));
    }
    var n = new Map();
    return new Proxy(t, {
      get: function get(e, r) {
        return n.has(r) || n.set(r, t(r)), n.get(r);
      }
    });
  }(function (e, t, n, r) {
    var o = t.forwardMotionProps,
      i = void 0 !== o && o,
      a = W(e) ? wt : St;
    return _p(_p({}, a), {
      preloadedFeatures: n,
      useRender: it(i),
      createVisualElement: r,
      Component: e
    });
  });
function ui(t) {
  var n = t.children,
    r = t.features,
    a = t.strict,
    s = void 0 !== a && a,
    u = m(f(!ci(r)), 2)[1],
    c = o(void 0);
  if (!ci(r)) {
    var l = r.renderer,
      d = v(r, ["renderer"]);
    c.current = l, w(d);
  }
  return i(function () {
    ci(r) && r().then(function (e) {
      var t = e.renderer;
      w(v(e, ["renderer"])), c.current = t, u(!0);
    });
  }, []), e.createElement(A.Provider, {
    value: {
      renderer: c.current,
      strict: s
    }
  }, n);
}
function ci(e) {
  return "function" == typeof e;
}
var li = _p(_p({
    renderer: function renderer(e, t) {
      return W(e) ? ai(t, {
        enableHardwareAcceleration: !1
      }) : ii(t, {
        enableHardwareAcceleration: !0
      });
    }
  }, Qr), ur),
  fi = {
    exports: {}
  },
  di = {},
  pi = 60103,
  vi = 60106,
  mi = 60107,
  hi = 60108,
  yi = 60114,
  gi = 60109,
  bi = 60110,
  wi = 60112,
  xi = 60113,
  Si = 60120,
  Ai = 60115,
  ki = 60116,
  Ei = 60121,
  Ci = 60122,
  Ti = 60117,
  Pi = 60129,
  Oi = 60131;
if ("function" == typeof Symbol && Symbol.for) {
  var Ri = Symbol.for;
  pi = Ri("react.element"), vi = Ri("react.portal"), mi = Ri("react.fragment"), hi = Ri("react.strict_mode"), yi = Ri("react.profiler"), gi = Ri("react.provider"), bi = Ri("react.context"), wi = Ri("react.forward_ref"), xi = Ri("react.suspense"), Si = Ri("react.suspense_list"), Ai = Ri("react.memo"), ki = Ri("react.lazy"), Ei = Ri("react.block"), Ci = Ri("react.server.block"), Ti = Ri("react.fundamental"), Pi = Ri("react.debug_trace_mode"), Oi = Ri("react.legacy_hidden");
}
function Ii(e) {
  if ("object" == typeof e && null !== e) {
    var t = e.$$typeof;
    switch (t) {
      case pi:
        switch (e = e.type) {
          case mi:
          case yi:
          case hi:
          case xi:
          case Si:
            return e;
          default:
            switch (e = e && e.$$typeof) {
              case bi:
              case wi:
              case ki:
              case Ai:
              case gi:
                return e;
              default:
                return t;
            }
        }
      case vi:
        return t;
    }
  }
}
var Mi = gi,
  Vi = pi,
  _i = wi,
  Ni = mi,
  ji = ki,
  $i = Ai,
  Li = vi,
  Di = yi,
  zi = hi,
  Fi = xi;
di.ContextConsumer = bi, di.ContextProvider = Mi, di.Element = Vi, di.ForwardRef = _i, di.Fragment = Ni, di.Lazy = ji, di.Memo = $i, di.Portal = Li, di.Profiler = Di, di.StrictMode = zi, di.Suspense = Fi, di.isAsyncMode = function () {
  return !1;
}, di.isConcurrentMode = function () {
  return !1;
}, di.isContextConsumer = function (e) {
  return Ii(e) === bi;
}, di.isContextProvider = function (e) {
  return Ii(e) === gi;
}, di.isElement = function (e) {
  return "object" == typeof e && null !== e && e.$$typeof === pi;
}, di.isForwardRef = function (e) {
  return Ii(e) === wi;
}, di.isFragment = function (e) {
  return Ii(e) === mi;
}, di.isLazy = function (e) {
  return Ii(e) === ki;
}, di.isMemo = function (e) {
  return Ii(e) === Ai;
}, di.isPortal = function (e) {
  return Ii(e) === vi;
}, di.isProfiler = function (e) {
  return Ii(e) === yi;
}, di.isStrictMode = function (e) {
  return Ii(e) === hi;
}, di.isSuspense = function (e) {
  return Ii(e) === xi;
}, di.isValidElementType = function (e) {
  return "string" == typeof e || "function" == typeof e || e === mi || e === yi || e === Pi || e === hi || e === xi || e === Si || e === Oi || "object" == typeof e && null !== e && (e.$$typeof === ki || e.$$typeof === Ai || e.$$typeof === gi || e.$$typeof === bi || e.$$typeof === wi || e.$$typeof === Ti || e.$$typeof === Ei || e[0] === Ci);
}, di.typeOf = Ii;
var Bi = {};
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function Hi(e) {
  function t(e, r, u, c, d) {
    for (var p, v, m, h, w, S = 0, A = 0, k = 0, E = 0, C = 0, M = 0, _ = m = p = 0, j = 0, $ = 0, L = 0, D = 0, z = u.length, F = z - 1, B = "", H = "", U = "", Y = ""; j < z;) {
      if (v = u.charCodeAt(j), j === F && 0 !== A + E + k + S && (0 !== A && (v = 47 === A ? 10 : 47), E = k = S = 0, z++, F++), 0 === A + E + k + S) {
        if (j === F && (0 < $ && (B = B.replace(f, "")), 0 < B.trim().length)) {
          switch (v) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              B += u.charAt(j);
          }
          v = 59;
        }
        switch (v) {
          case 123:
            for (p = (B = B.trim()).charCodeAt(0), m = 1, D = ++j; j < z;) {
              switch (v = u.charCodeAt(j)) {
                case 123:
                  m++;
                  break;
                case 125:
                  m--;
                  break;
                case 47:
                  switch (v = u.charCodeAt(j + 1)) {
                    case 42:
                    case 47:
                      e: {
                        for (_ = j + 1; _ < F; ++_) switch (u.charCodeAt(_)) {
                          case 47:
                            if (42 === v && 42 === u.charCodeAt(_ - 1) && j + 2 !== _) {
                              j = _ + 1;
                              break e;
                            }
                            break;
                          case 10:
                            if (47 === v) {
                              j = _ + 1;
                              break e;
                            }
                        }
                        j = _;
                      }
                  }
                  break;
                case 91:
                  v++;
                case 40:
                  v++;
                case 34:
                case 39:
                  for (; j++ < F && u.charCodeAt(j) !== v;);
              }
              if (0 === m) break;
              j++;
            }
            if (m = u.substring(D, j), 0 === p && (p = (B = B.replace(l, "").trim()).charCodeAt(0)), 64 === p) {
              switch (0 < $ && (B = B.replace(f, "")), v = B.charCodeAt(1)) {
                case 100:
                case 109:
                case 115:
                case 45:
                  $ = r;
                  break;
                default:
                  $ = I;
              }
              if (D = (m = t(r, $, m, v, d + 1)).length, 0 < V && (w = s(3, m, $ = n(I, B, L), r, P, T, D, v, d, c), B = $.join(""), void 0 !== w && 0 === (D = (m = w.trim()).length) && (v = 0, m = "")), 0 < D) switch (v) {
                case 115:
                  B = B.replace(x, a);
                case 100:
                case 109:
                case 45:
                  m = B + "{" + m + "}";
                  break;
                case 107:
                  m = (B = B.replace(y, "$1 $2")) + "{" + m + "}", m = 1 === R || 2 === R && i("@" + m, 3) ? "@-webkit-" + m + "@" + m : "@" + m;
                  break;
                default:
                  m = B + m, 112 === c && (H += m, m = "");
              } else m = "";
            } else m = t(r, n(r, B, L), m, c, d + 1);
            U += m, m = L = $ = _ = p = 0, B = "", v = u.charCodeAt(++j);
            break;
          case 125:
          case 59:
            if (1 < (D = (B = (0 < $ ? B.replace(f, "") : B).trim()).length)) switch (0 === _ && (p = B.charCodeAt(0), 45 === p || 96 < p && 123 > p) && (D = (B = B.replace(" ", ":")).length), 0 < V && void 0 !== (w = s(1, B, r, e, P, T, H.length, c, d, c)) && 0 === (D = (B = w.trim()).length) && (B = "\0\0"), p = B.charCodeAt(0), v = B.charCodeAt(1), p) {
              case 0:
                break;
              case 64:
                if (105 === v || 99 === v) {
                  Y += B + u.charAt(j);
                  break;
                }
              default:
                58 !== B.charCodeAt(D - 1) && (H += o(B, p, v, B.charCodeAt(2)));
            }
            L = $ = _ = p = 0, B = "", v = u.charCodeAt(++j);
        }
      }
      switch (v) {
        case 13:
        case 10:
          47 === A ? A = 0 : 0 === 1 + p && 107 !== c && 0 < B.length && ($ = 1, B += "\0"), 0 < V * N && s(0, B, r, e, P, T, H.length, c, d, c), T = 1, P++;
          break;
        case 59:
        case 125:
          if (0 === A + E + k + S) {
            T++;
            break;
          }
        default:
          switch (T++, h = u.charAt(j), v) {
            case 9:
            case 32:
              if (0 === E + S + A) switch (C) {
                case 44:
                case 58:
                case 9:
                case 32:
                  h = "";
                  break;
                default:
                  32 !== v && (h = " ");
              }
              break;
            case 0:
              h = "\\0";
              break;
            case 12:
              h = "\\f";
              break;
            case 11:
              h = "\\v";
              break;
            case 38:
              0 === E + A + S && ($ = L = 1, h = "\f" + h);
              break;
            case 108:
              if (0 === E + A + S + O && 0 < _) switch (j - _) {
                case 2:
                  112 === C && 58 === u.charCodeAt(j - 3) && (O = C);
                case 8:
                  111 === M && (O = M);
              }
              break;
            case 58:
              0 === E + A + S && (_ = j);
              break;
            case 44:
              0 === A + k + E + S && ($ = 1, h += "\r");
              break;
            case 34:
            case 39:
              0 === A && (E = E === v ? 0 : 0 === E ? v : E);
              break;
            case 91:
              0 === E + A + k && S++;
              break;
            case 93:
              0 === E + A + k && S--;
              break;
            case 41:
              0 === E + A + S && k--;
              break;
            case 40:
              if (0 === E + A + S) {
                if (0 === p) if (2 * C + 3 * M == 533) ;else p = 1;
                k++;
              }
              break;
            case 64:
              0 === A + k + E + S + _ + m && (m = 1);
              break;
            case 42:
            case 47:
              if (!(0 < E + S + k)) switch (A) {
                case 0:
                  switch (2 * v + 3 * u.charCodeAt(j + 1)) {
                    case 235:
                      A = 47;
                      break;
                    case 220:
                      D = j, A = 42;
                  }
                  break;
                case 42:
                  47 === v && 42 === C && D + 2 !== j && (33 === u.charCodeAt(D + 2) && (H += u.substring(D, j + 1)), h = "", A = 0);
              }
          }
          0 === A && (B += h);
      }
      M = C, C = v, j++;
    }
    if (0 < (D = H.length)) {
      if ($ = r, 0 < V && void 0 !== (w = s(2, H, $, e, P, T, D, c, d, c)) && 0 === (H = w).length) return Y + H + U;
      if (H = $.join(",") + "{" + H + "}", 0 != R * O) {
        switch (2 !== R || i(H, 2) || (O = 0), O) {
          case 111:
            H = H.replace(b, ":-moz-$1") + H;
            break;
          case 112:
            H = H.replace(g, "::-webkit-input-$1") + H.replace(g, "::-moz-$1") + H.replace(g, ":-ms-input-$1") + H;
        }
        O = 0;
      }
    }
    return Y + H + U;
  }
  function n(e, t, n) {
    var o = t.trim().split(m);
    t = o;
    var i = o.length,
      a = e.length;
    switch (a) {
      case 0:
      case 1:
        var s = 0;
        for (e = 0 === a ? "" : e[0] + " "; s < i; ++s) t[s] = r(e, t[s], n).trim();
        break;
      default:
        var u = s = 0;
        for (t = []; s < i; ++s) for (var c = 0; c < a; ++c) t[u++] = r(e[c] + " ", o[s], n).trim();
    }
    return t;
  }
  function r(e, t, n) {
    var r = t.charCodeAt(0);
    switch (33 > r && (r = (t = t.trim()).charCodeAt(0)), r) {
      case 38:
        return t.replace(h, "$1" + e.trim());
      case 58:
        return e.trim() + t.replace(h, "$1" + e.trim());
      default:
        if (0 < 1 * n && 0 < t.indexOf("\f")) return t.replace(h, (58 === e.charCodeAt(0) ? "" : "$1") + e.trim());
    }
    return e + t;
  }
  function o(e, t, n, r) {
    var a = e + ";",
      s = 2 * t + 3 * n + 4 * r;
    if (944 === s) {
      e = a.indexOf(":", 9) + 1;
      var u = a.substring(e, a.length - 1).trim();
      return u = a.substring(0, e).trim() + u + ";", 1 === R || 2 === R && i(u, 1) ? "-webkit-" + u + u : u;
    }
    if (0 === R || 2 === R && !i(a, 1)) return a;
    switch (s) {
      case 1015:
        return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
      case 951:
        return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
      case 963:
        return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
      case 1009:
        if (100 !== a.charCodeAt(4)) break;
      case 969:
      case 942:
        return "-webkit-" + a + a;
      case 978:
        return "-webkit-" + a + "-moz-" + a + a;
      case 1019:
      case 983:
        return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
      case 883:
        if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
        if (0 < a.indexOf("image-set(", 11)) return a.replace(C, "$1-webkit-$2") + a;
        break;
      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
          case 115:
            return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
          case 98:
            return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
        }
        return "-webkit-" + a + "-ms-" + a + a;
      case 964:
        return "-webkit-" + a + "-ms-flex-" + a + a;
      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        return "-webkit-box-pack" + (u = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify")) + "-webkit-" + a + "-ms-flex-pack" + u + a;
      case 1005:
        return p.test(a) ? a.replace(d, ":-webkit-") + a.replace(d, ":-moz-") + a : a;
      case 1e3:
        switch (t = (u = a.substring(13).trim()).indexOf("-") + 1, u.charCodeAt(0) + u.charCodeAt(t)) {
          case 226:
            u = a.replace(w, "tb");
            break;
          case 232:
            u = a.replace(w, "tb-rl");
            break;
          case 220:
            u = a.replace(w, "lr");
            break;
          default:
            return a;
        }
        return "-webkit-" + a + "-ms-" + u + a;
      case 1017:
        if (-1 === a.indexOf("sticky", 9)) break;
      case 975:
        switch (t = (a = e).length - 10, s = (u = (33 === a.charCodeAt(t) ? a.substring(0, t) : a).substring(e.indexOf(":", 7) + 1).trim()).charCodeAt(0) + (0 | u.charCodeAt(7))) {
          case 203:
            if (111 > u.charCodeAt(8)) break;
          case 115:
            a = a.replace(u, "-webkit-" + u) + ";" + a;
            break;
          case 207:
          case 102:
            a = a.replace(u, "-webkit-" + (102 < s ? "inline-" : "") + "box") + ";" + a.replace(u, "-webkit-" + u) + ";" + a.replace(u, "-ms-" + u + "box") + ";" + a;
        }
        return a + ";";
      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return u = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + u + "-ms-flex-" + u + a;
          case 115:
            return "-webkit-" + a + "-ms-flex-item-" + a.replace(A, "") + a;
          default:
            return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(A, "") + a;
        }
        break;
      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
      case 931:
      case 953:
        if (!0 === E.test(e)) return 115 === (u = e.substring(e.indexOf(":") + 1)).charCodeAt(0) ? o(e.replace("stretch", "fill-available"), t, n, r).replace(":fill-available", ":stretch") : a.replace(u, "-webkit-" + u) + a.replace(u, "-moz-" + u.replace("fill-", "")) + a;
        break;
      case 962:
        if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === n + r && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(v, "$1-webkit-$2") + a;
    }
    return a;
  }
  function i(e, t) {
    var n = e.indexOf(1 === t ? ":" : "{"),
      r = e.substring(0, 3 !== t ? n : 10);
    return n = e.substring(n + 1, e.length - 1), _(2 !== t ? r : r.replace(k, "$1"), n, t);
  }
  function a(e, t) {
    var n = o(t, t.charCodeAt(0), t.charCodeAt(1), t.charCodeAt(2));
    return n !== t + ";" ? n.replace(S, " or ($1)").substring(4) : "(" + t + ")";
  }
  function s(e, t, n, r, o, i, a, s, u, l) {
    for (var f, d = 0, p = t; d < V; ++d) switch (f = M[d].call(c, e, p, n, r, o, i, a, s, u, l)) {
      case void 0:
      case !1:
      case !0:
      case null:
        break;
      default:
        p = f;
    }
    if (p !== t) return p;
  }
  function u(e) {
    return void 0 !== (e = e.prefix) && (_ = null, e ? "function" != typeof e ? R = 1 : (R = 2, _ = e) : R = 0), u;
  }
  function c(e, n) {
    var r = e;
    if (33 > r.charCodeAt(0) && (r = r.trim()), r = [r], 0 < V) {
      var o = s(-1, n, r, r, P, T, 0, 0, 0, 0);
      void 0 !== o && "string" == typeof o && (n = o);
    }
    var i = t(I, r, n, 0, 0);
    return 0 < V && void 0 !== (o = s(-2, i, r, r, P, T, i.length, 0, 0, 0)) && (i = o), "", O = 0, T = P = 1, i;
  }
  var l = /^\0+/g,
    f = /[\0\r\f]/g,
    d = /: */g,
    p = /zoo|gra/,
    v = /([,: ])(transform)/g,
    m = /,\r+?/g,
    h = /([\t\r\n ])*\f?&/g,
    y = /@(k\w+)\s*(\S*)\s*/,
    g = /::(place)/g,
    b = /:(read-only)/g,
    w = /[svh]\w+-[tblr]{2}/,
    x = /\(\s*(.*)\s*\)/g,
    S = /([\s\S]*?);/g,
    A = /-self|flex-/g,
    k = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
    E = /stretch|:\s*\w+\-(?:conte|avail)/,
    C = /([^-])(image-set\()/,
    T = 1,
    P = 1,
    O = 0,
    R = 1,
    I = [],
    M = [],
    V = 0,
    _ = null,
    N = 0;
  return c.use = function e(t) {
    switch (t) {
      case void 0:
      case null:
        V = M.length = 0;
        break;
      default:
        if ("function" == typeof t) M[V++] = t;else if ("object" == typeof t) for (var n = 0, r = t.length; n < r; ++n) e(t[n]);else N = 0 | !!t;
    }
    return e;
  }, c.set = u, void 0 !== e && u(e), c;
}
"production" !== process.env.NODE_ENV && function () {
  var e = 60103,
    t = 60106,
    n = 60107,
    r = 60108,
    o = 60114,
    i = 60109,
    a = 60110,
    s = 60112,
    u = 60113,
    c = 60120,
    l = 60115,
    f = 60116,
    d = 60121,
    p = 60122,
    v = 60117,
    m = 60129,
    h = 60131;
  if ("function" == typeof Symbol && Symbol.for) {
    var y = Symbol.for;
    e = y("react.element"), t = y("react.portal"), n = y("react.fragment"), r = y("react.strict_mode"), o = y("react.profiler"), i = y("react.provider"), a = y("react.context"), s = y("react.forward_ref"), u = y("react.suspense"), c = y("react.suspense_list"), l = y("react.memo"), f = y("react.lazy"), d = y("react.block"), p = y("react.server.block"), v = y("react.fundamental"), y("react.scope"), y("react.opaque.id"), m = y("react.debug_trace_mode"), y("react.offscreen"), h = y("react.legacy_hidden");
  }
  function g(d) {
    if ("object" == typeof d && null !== d) {
      var p = d.$$typeof;
      switch (p) {
        case e:
          var v = d.type;
          switch (v) {
            case n:
            case o:
            case r:
            case u:
            case c:
              return v;
            default:
              var m = v && v.$$typeof;
              switch (m) {
                case a:
                case s:
                case f:
                case l:
                case i:
                  return m;
                default:
                  return p;
              }
          }
        case t:
          return p;
      }
    }
  }
  var b = a,
    w = i,
    x = e,
    S = s,
    A = n,
    k = f,
    E = l,
    C = t,
    T = o,
    P = r,
    O = u,
    R = !1,
    I = !1;
  Bi.ContextConsumer = b, Bi.ContextProvider = w, Bi.Element = x, Bi.ForwardRef = S, Bi.Fragment = A, Bi.Lazy = k, Bi.Memo = E, Bi.Portal = C, Bi.Profiler = T, Bi.StrictMode = P, Bi.Suspense = O, Bi.isAsyncMode = function (e) {
    return R || (R = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
  }, Bi.isConcurrentMode = function (e) {
    return I || (I = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
  }, Bi.isContextConsumer = function (e) {
    return g(e) === a;
  }, Bi.isContextProvider = function (e) {
    return g(e) === i;
  }, Bi.isElement = function (t) {
    return "object" == typeof t && null !== t && t.$$typeof === e;
  }, Bi.isForwardRef = function (e) {
    return g(e) === s;
  }, Bi.isFragment = function (e) {
    return g(e) === n;
  }, Bi.isLazy = function (e) {
    return g(e) === f;
  }, Bi.isMemo = function (e) {
    return g(e) === l;
  }, Bi.isPortal = function (e) {
    return g(e) === t;
  }, Bi.isProfiler = function (e) {
    return g(e) === o;
  }, Bi.isStrictMode = function (e) {
    return g(e) === r;
  }, Bi.isSuspense = function (e) {
    return g(e) === u;
  }, Bi.isValidElementType = function (e) {
    return "string" == typeof e || "function" == typeof e || e === n || e === o || e === m || e === r || e === u || e === c || e === h || "object" == typeof e && null !== e && (e.$$typeof === f || e.$$typeof === l || e.$$typeof === i || e.$$typeof === a || e.$$typeof === s || e.$$typeof === v || e.$$typeof === d || e[0] === p);
  }, Bi.typeOf = g;
}(), "production" === process.env.NODE_ENV ? fi.exports = di : fi.exports = Bi;
var Ui = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function Yi(e) {
  var t = Object.create(null);
  return function (n) {
    return void 0 === t[n] && (t[n] = e(n)), t[n];
  };
}
var Xi = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/,
  qi = Yi(function (e) {
    return Xi.test(e) || 111 === e.charCodeAt(0) && 110 === e.charCodeAt(1) && e.charCodeAt(2) < 91;
  }),
  Wi = {
    exports: {}
  },
  Gi = {},
  Ki = "function" == typeof Symbol && Symbol.for,
  Zi = Ki ? Symbol.for("react.element") : 60103,
  Ji = Ki ? Symbol.for("react.portal") : 60106,
  Qi = Ki ? Symbol.for("react.fragment") : 60107,
  ea = Ki ? Symbol.for("react.strict_mode") : 60108,
  ta = Ki ? Symbol.for("react.profiler") : 60114,
  na = Ki ? Symbol.for("react.provider") : 60109,
  ra = Ki ? Symbol.for("react.context") : 60110,
  oa = Ki ? Symbol.for("react.async_mode") : 60111,
  ia = Ki ? Symbol.for("react.concurrent_mode") : 60111,
  aa = Ki ? Symbol.for("react.forward_ref") : 60112,
  sa = Ki ? Symbol.for("react.suspense") : 60113,
  ua = Ki ? Symbol.for("react.suspense_list") : 60120,
  ca = Ki ? Symbol.for("react.memo") : 60115,
  la = Ki ? Symbol.for("react.lazy") : 60116,
  fa = Ki ? Symbol.for("react.block") : 60121,
  da = Ki ? Symbol.for("react.fundamental") : 60117,
  pa = Ki ? Symbol.for("react.responder") : 60118,
  va = Ki ? Symbol.for("react.scope") : 60119;
function ma(e) {
  if ("object" == typeof e && null !== e) {
    var t = e.$$typeof;
    switch (t) {
      case Zi:
        switch (e = e.type) {
          case oa:
          case ia:
          case Qi:
          case ta:
          case ea:
          case sa:
            return e;
          default:
            switch (e = e && e.$$typeof) {
              case ra:
              case aa:
              case la:
              case ca:
              case na:
                return e;
              default:
                return t;
            }
        }
      case Ji:
        return t;
    }
  }
}
function ha(e) {
  return ma(e) === ia;
}
Gi.AsyncMode = oa, Gi.ConcurrentMode = ia, Gi.ContextConsumer = ra, Gi.ContextProvider = na, Gi.Element = Zi, Gi.ForwardRef = aa, Gi.Fragment = Qi, Gi.Lazy = la, Gi.Memo = ca, Gi.Portal = Ji, Gi.Profiler = ta, Gi.StrictMode = ea, Gi.Suspense = sa, Gi.isAsyncMode = function (e) {
  return ha(e) || ma(e) === oa;
}, Gi.isConcurrentMode = ha, Gi.isContextConsumer = function (e) {
  return ma(e) === ra;
}, Gi.isContextProvider = function (e) {
  return ma(e) === na;
}, Gi.isElement = function (e) {
  return "object" == typeof e && null !== e && e.$$typeof === Zi;
}, Gi.isForwardRef = function (e) {
  return ma(e) === aa;
}, Gi.isFragment = function (e) {
  return ma(e) === Qi;
}, Gi.isLazy = function (e) {
  return ma(e) === la;
}, Gi.isMemo = function (e) {
  return ma(e) === ca;
}, Gi.isPortal = function (e) {
  return ma(e) === Ji;
}, Gi.isProfiler = function (e) {
  return ma(e) === ta;
}, Gi.isStrictMode = function (e) {
  return ma(e) === ea;
}, Gi.isSuspense = function (e) {
  return ma(e) === sa;
}, Gi.isValidElementType = function (e) {
  return "string" == typeof e || "function" == typeof e || e === Qi || e === ia || e === ta || e === ea || e === sa || e === ua || "object" == typeof e && null !== e && (e.$$typeof === la || e.$$typeof === ca || e.$$typeof === na || e.$$typeof === ra || e.$$typeof === aa || e.$$typeof === da || e.$$typeof === pa || e.$$typeof === va || e.$$typeof === fa);
}, Gi.typeOf = ma;
var ya = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"production" !== process.env.NODE_ENV && function () {
  var e = "function" == typeof Symbol && Symbol.for,
    t = e ? Symbol.for("react.element") : 60103,
    n = e ? Symbol.for("react.portal") : 60106,
    r = e ? Symbol.for("react.fragment") : 60107,
    o = e ? Symbol.for("react.strict_mode") : 60108,
    i = e ? Symbol.for("react.profiler") : 60114,
    a = e ? Symbol.for("react.provider") : 60109,
    s = e ? Symbol.for("react.context") : 60110,
    u = e ? Symbol.for("react.async_mode") : 60111,
    c = e ? Symbol.for("react.concurrent_mode") : 60111,
    l = e ? Symbol.for("react.forward_ref") : 60112,
    f = e ? Symbol.for("react.suspense") : 60113,
    d = e ? Symbol.for("react.suspense_list") : 60120,
    p = e ? Symbol.for("react.memo") : 60115,
    v = e ? Symbol.for("react.lazy") : 60116,
    m = e ? Symbol.for("react.block") : 60121,
    h = e ? Symbol.for("react.fundamental") : 60117,
    y = e ? Symbol.for("react.responder") : 60118,
    g = e ? Symbol.for("react.scope") : 60119;
  function b(e) {
    if ("object" == typeof e && null !== e) {
      var d = e.$$typeof;
      switch (d) {
        case t:
          var m = e.type;
          switch (m) {
            case u:
            case c:
            case r:
            case i:
            case o:
            case f:
              return m;
            default:
              var h = m && m.$$typeof;
              switch (h) {
                case s:
                case l:
                case v:
                case p:
                case a:
                  return h;
                default:
                  return d;
              }
          }
        case n:
          return d;
      }
    }
  }
  var w = u,
    x = c,
    S = s,
    A = a,
    k = t,
    E = l,
    C = r,
    T = v,
    P = p,
    O = n,
    R = i,
    I = o,
    M = f,
    V = !1;
  function _(e) {
    return b(e) === c;
  }
  ya.AsyncMode = w, ya.ConcurrentMode = x, ya.ContextConsumer = S, ya.ContextProvider = A, ya.Element = k, ya.ForwardRef = E, ya.Fragment = C, ya.Lazy = T, ya.Memo = P, ya.Portal = O, ya.Profiler = R, ya.StrictMode = I, ya.Suspense = M, ya.isAsyncMode = function (e) {
    return V || (V = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), _(e) || b(e) === u;
  }, ya.isConcurrentMode = _, ya.isContextConsumer = function (e) {
    return b(e) === s;
  }, ya.isContextProvider = function (e) {
    return b(e) === a;
  }, ya.isElement = function (e) {
    return "object" == typeof e && null !== e && e.$$typeof === t;
  }, ya.isForwardRef = function (e) {
    return b(e) === l;
  }, ya.isFragment = function (e) {
    return b(e) === r;
  }, ya.isLazy = function (e) {
    return b(e) === v;
  }, ya.isMemo = function (e) {
    return b(e) === p;
  }, ya.isPortal = function (e) {
    return b(e) === n;
  }, ya.isProfiler = function (e) {
    return b(e) === i;
  }, ya.isStrictMode = function (e) {
    return b(e) === o;
  }, ya.isSuspense = function (e) {
    return b(e) === f;
  }, ya.isValidElementType = function (e) {
    return "string" == typeof e || "function" == typeof e || e === r || e === c || e === i || e === o || e === f || e === d || "object" == typeof e && null !== e && (e.$$typeof === v || e.$$typeof === p || e.$$typeof === a || e.$$typeof === s || e.$$typeof === l || e.$$typeof === h || e.$$typeof === y || e.$$typeof === g || e.$$typeof === m);
  }, ya.typeOf = b;
}(), "production" === process.env.NODE_ENV ? Wi.exports = Gi : Wi.exports = ya;
var ga = Wi.exports,
  ba = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  },
  wa = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  },
  xa = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  },
  Sa = {};
function Aa(e) {
  return ga.isMemo(e) ? xa : Sa[e.$$typeof] || ba;
}
Sa[ga.ForwardRef] = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Sa[ga.Memo] = xa;
var ka = Object.defineProperty,
  Ea = Object.getOwnPropertyNames,
  Ca = Object.getOwnPropertySymbols,
  Ta = Object.getOwnPropertyDescriptor,
  Pa = Object.getPrototypeOf,
  Oa = Object.prototype;
var Ra = function e(t, n, r) {
  if ("string" != typeof n) {
    if (Oa) {
      var o = Pa(n);
      o && o !== Oa && e(t, o, r);
    }
    var i = Ea(n);
    Ca && (i = i.concat(Ca(n)));
    for (var a = Aa(t), s = Aa(n), u = 0; u < i.length; ++u) {
      var c = i[u];
      if (!(wa[c] || r && r[c] || s && s[c] || a && a[c])) {
        var l = Ta(n, c);
        try {
          ka(t, c, l);
        } catch (e) {}
      }
    }
  }
  return t;
};
function Ia() {
  return (Ia = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }).apply(this, arguments);
}
var Ma = function Ma(e, t) {
    for (var n = [e[0]], r = 0, o = t.length; r < o; r += 1) n.push(t[r], e[r + 1]);
    return n;
  },
  Va = function Va(e) {
    return null !== e && "object" == typeof e && "[object Object]" === (e.toString ? e.toString() : Object.prototype.toString.call(e)) && !fi.exports.typeOf(e);
  },
  _a = Object.freeze([]),
  Na = Object.freeze({});
function ja(e) {
  return "function" == typeof e;
}
function $a(e) {
  return "production" !== process.env.NODE_ENV && "string" == typeof e && e || e.displayName || e.name || "Component";
}
function La(e) {
  return e && "string" == typeof e.styledComponentId;
}
var Da = "undefined" != typeof process && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled",
  za = "undefined" != typeof window && "HTMLElement" in window,
  Fa = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : "undefined" != typeof process && void 0 !== process.env.REACT_APP_SC_DISABLE_SPEEDY && "" !== process.env.REACT_APP_SC_DISABLE_SPEEDY ? "false" !== process.env.REACT_APP_SC_DISABLE_SPEEDY && process.env.REACT_APP_SC_DISABLE_SPEEDY : "undefined" != typeof process && void 0 !== process.env.SC_DISABLE_SPEEDY && "" !== process.env.SC_DISABLE_SPEEDY ? "false" !== process.env.SC_DISABLE_SPEEDY && process.env.SC_DISABLE_SPEEDY : "production" !== process.env.NODE_ENV),
  Ba = "production" !== process.env.NODE_ENV ? {
    1: "Cannot create styled-component for component: %s.\n\n",
    2: "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",
    3: "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
    4: "The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",
    5: "The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",
    6: "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",
    7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',
    8: 'ThemeProvider: Please make your "theme" prop an object.\n\n',
    9: "Missing document `<head>`\n\n",
    10: "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
    11: "_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",
    12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",
    13: "%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n",
    14: 'ThemeProvider: "theme" prop is required.\n\n',
    15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",
    16: "Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n",
    17: "CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n"
  } : {};
function Ha() {
  for (var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1) t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
  return t.forEach(function (t) {
    e = e.replace(/%[a-z]/, t);
  }), e;
}
function Ua(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  throw "production" === process.env.NODE_ENV ? new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : "")) : new Error(Ha.apply(void 0, [Ba[e]].concat(n)).trim());
}
var Ya = function () {
    function e(e) {
      this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function (e) {
      for (var t = 0, n = 0; n < e; n++) t += this.groupSizes[n];
      return t;
    }, t.insertRules = function (e, t) {
      if (e >= this.groupSizes.length) {
        for (var n = this.groupSizes, r = n.length, o = r; e >= o;) (o <<= 1) < 0 && Ua(16, "" + e);
        this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
        for (var i = r; i < o; i++) this.groupSizes[i] = 0;
      }
      for (var a = this.indexOfGroup(e + 1), s = 0, u = t.length; s < u; s++) this.tag.insertRule(a, t[s]) && (this.groupSizes[e]++, a++);
    }, t.clearGroup = function (e) {
      if (e < this.length) {
        var t = this.groupSizes[e],
          n = this.indexOfGroup(e),
          r = n + t;
        this.groupSizes[e] = 0;
        for (var o = n; o < r; o++) this.tag.deleteRule(n);
      }
    }, t.getGroup = function (e) {
      var t = "";
      if (e >= this.length || 0 === this.groupSizes[e]) return t;
      for (var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, i = r; i < o; i++) t += this.tag.getRule(i) + "/*!sc*/\n";
      return t;
    }, e;
  }(),
  Xa = new Map(),
  qa = new Map(),
  Wa = 1,
  Ga = function Ga(e) {
    if (Xa.has(e)) return Xa.get(e);
    for (; qa.has(Wa);) Wa++;
    var t = Wa++;
    return "production" !== process.env.NODE_ENV && ((0 | t) < 0 || t > 1 << 30) && Ua(16, "" + t), Xa.set(e, t), qa.set(t, e), t;
  },
  Ka = function Ka(e) {
    return qa.get(e);
  },
  Za = function Za(e, t) {
    t >= Wa && (Wa = t + 1), Xa.set(e, t), qa.set(t, e);
  },
  Ja = "style[" + Da + '][data-styled-version="5.3.5"]',
  Qa = new RegExp("^" + Da + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),
  es = function es(e, t, n) {
    for (var r, o = n.split(","), i = 0, a = o.length; i < a; i++) (r = o[i]) && e.registerName(t, r);
  },
  ts = function ts(e, t) {
    for (var n = (t.textContent || "").split("/*!sc*/\n"), r = [], o = 0, i = n.length; o < i; o++) {
      var a = n[o].trim();
      if (a) {
        var s = a.match(Qa);
        if (s) {
          var u = 0 | parseInt(s[1], 10),
            c = s[2];
          0 !== u && (Za(c, u), es(e, c, s[3]), e.getTag().insertRules(u, r)), r.length = 0;
        } else r.push(a);
      }
    }
  },
  ns = function ns(e) {
    var t = document.head,
      n = e || t,
      r = document.createElement("style"),
      o = function (e) {
        for (var t = e.childNodes, n = t.length; n >= 0; n--) {
          var r = t[n];
          if (r && 1 === r.nodeType && r.hasAttribute(Da)) return r;
        }
      }(n),
      i = void 0 !== o ? o.nextSibling : null;
    r.setAttribute(Da, "active"), r.setAttribute("data-styled-version", "5.3.5");
    var a = "undefined" != typeof window && void 0 !== window.__webpack_nonce__ ? window.__webpack_nonce__ : null;
    return a && r.setAttribute("nonce", a), n.insertBefore(r, i), r;
  },
  rs = function () {
    function e(e) {
      var t = this.element = ns(e);
      t.appendChild(document.createTextNode("")), this.sheet = function (e) {
        if (e.sheet) return e.sheet;
        for (var t = document.styleSheets, n = 0, r = t.length; n < r; n++) {
          var o = t[n];
          if (o.ownerNode === e) return o;
        }
        Ua(17);
      }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function (e, t) {
      try {
        return this.sheet.insertRule(t, e), this.length++, !0;
      } catch (e) {
        return !1;
      }
    }, t.deleteRule = function (e) {
      this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function (e) {
      var t = this.sheet.cssRules[e];
      return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
  }(),
  os = function () {
    function e(e) {
      var t = this.element = ns(e);
      this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function (e, t) {
      if (e <= this.length && e >= 0) {
        var n = document.createTextNode(t),
          r = this.nodes[e];
        return this.element.insertBefore(n, r || null), this.length++, !0;
      }
      return !1;
    }, t.deleteRule = function (e) {
      this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function (e) {
      return e < this.length ? this.nodes[e].textContent : "";
    }, e;
  }(),
  is = function () {
    function e(e) {
      this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function (e, t) {
      return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function (e) {
      this.rules.splice(e, 1), this.length--;
    }, t.getRule = function (e) {
      return e < this.length ? this.rules[e] : "";
    }, e;
  }(),
  as = za,
  ss = {
    isServer: !za,
    useCSSOMInjection: !Fa
  },
  us = function () {
    function e(e, t, n) {
      void 0 === e && (e = Na), void 0 === t && (t = {}), this.options = Ia({}, ss, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && za && as && (as = !1, function (e) {
        for (var t = document.querySelectorAll(Ja), n = 0, r = t.length; n < r; n++) {
          var o = t[n];
          o && "active" !== o.getAttribute(Da) && (ts(e, o), o.parentNode && o.parentNode.removeChild(o));
        }
      }(this));
    }
    e.registerId = function (e) {
      return Ga(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function (t, n) {
      return void 0 === n && (n = !0), new e(Ia({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function (e) {
      return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function () {
      return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new is(o) : r ? new rs(o) : new os(o), new Ya(e)));
      var e, t, n, r, o;
    }, t.hasNameForId = function (e, t) {
      return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function (e, t) {
      if (Ga(e), this.names.has(e)) this.names.get(e).add(t);else {
        var n = new Set();
        n.add(t), this.names.set(e, n);
      }
    }, t.insertRules = function (e, t, n) {
      this.registerName(e, t), this.getTag().insertRules(Ga(e), n);
    }, t.clearNames = function (e) {
      this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function (e) {
      this.getTag().clearGroup(Ga(e)), this.clearNames(e);
    }, t.clearTag = function () {
      this.tag = void 0;
    }, t.toString = function () {
      return function (e) {
        for (var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++) {
          var i = Ka(o);
          if (void 0 !== i) {
            var a = e.names.get(i),
              s = t.getGroup(o);
            if (a && s && a.size) {
              var u = Da + ".g" + o + '[id="' + i + '"]',
                c = "";
              void 0 !== a && a.forEach(function (e) {
                e.length > 0 && (c += e + ",");
              }), r += "" + s + u + '{content:"' + c + '"}/*!sc*/\n';
            }
          }
        }
        return r;
      }(this);
    }, e;
  }(),
  cs = /(a)(d)/gi,
  ls = function ls(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
  };
function fs(e) {
  var t,
    n = "";
  for (t = Math.abs(e); t > 52; t = t / 52 | 0) n = ls(t % 52) + n;
  return (ls(t % 52) + n).replace(cs, "$1-$2");
}
var ds = function ds(e, t) {
    for (var n = t.length; n;) e = 33 * e ^ t.charCodeAt(--n);
    return e;
  },
  ps = function ps(e) {
    return ds(5381, e);
  };
var vs = ps("5.3.5"),
  ms = function () {
    function e(e, t, n) {
      this.rules = e, this.staticRulesId = "", this.isStatic = "production" === process.env.NODE_ENV && (void 0 === n || n.isStatic) && function (e) {
        for (var t = 0; t < e.length; t += 1) {
          var n = e[t];
          if (ja(n) && !La(n)) return !1;
        }
        return !0;
      }(e), this.componentId = t, this.baseHash = ds(vs, t), this.baseStyle = n, us.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function (e, t, n) {
      var r = this.componentId,
        o = [];
      if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
        if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);else {
          var i = Os(this.rules, e, t, n).join(""),
            a = fs(ds(this.baseHash, i) >>> 0);
          if (!t.hasNameForId(r, a)) {
            var s = n(i, "." + a, void 0, r);
            t.insertRules(r, a, s);
          }
          o.push(a), this.staticRulesId = a;
        }
      } else {
        for (var u = this.rules.length, c = ds(this.baseHash, n.hash), l = "", f = 0; f < u; f++) {
          var d = this.rules[f];
          if ("string" == typeof d) l += d, "production" !== process.env.NODE_ENV && (c = ds(c, d + f));else if (d) {
            var p = Os(d, e, t, n),
              v = Array.isArray(p) ? p.join("") : p;
            c = ds(c, v + f), l += v;
          }
        }
        if (l) {
          var m = fs(c >>> 0);
          if (!t.hasNameForId(r, m)) {
            var h = n(l, "." + m, void 0, r);
            t.insertRules(r, m, h);
          }
          o.push(m);
        }
      }
      return o.join(" ");
    }, e;
  }(),
  hs = /^\s*\/\/.*$/gm,
  ys = [":", "[", ".", "#"];
var gs = t.createContext();
gs.Consumer;
var bs = t.createContext(),
  ws = (bs.Consumer, new us()),
  xs = function (e) {
    var t,
      n,
      r,
      o,
      i = void 0 === e ? Na : e,
      a = i.options,
      s = void 0 === a ? Na : a,
      u = i.plugins,
      c = void 0 === u ? _a : u,
      l = new Hi(s),
      f = [],
      d = function (e) {
        function t(t) {
          if (t) try {
            e(t + "}");
          } catch (e) {}
        }
        return function (n, r, o, i, a, s, u, c, l, f) {
          switch (n) {
            case 1:
              if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
              break;
            case 2:
              if (0 === c) return r + "/*|*/";
              break;
            case 3:
              switch (c) {
                case 102:
                case 112:
                  return e(o[0] + r), "";
                default:
                  return r + (0 === f ? "/*|*/" : "");
              }
            case -2:
              r.split("/*|*/}").forEach(t);
          }
        };
      }(function (e) {
        f.push(e);
      }),
      p = function p(e, r, i) {
        return 0 === r && -1 !== ys.indexOf(i[n.length]) || i.match(o) ? e : "." + t;
      };
    function v(e, i, a, s) {
      void 0 === s && (s = "&");
      var u = e.replace(hs, ""),
        c = i && a ? a + " " + i + " { " + u + " }" : u;
      return t = s, n = i, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(a || !i ? "" : i, c);
    }
    return l.use([].concat(c, [function (e, t, o) {
      2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, p));
    }, d, function (e) {
      if (-2 === e) {
        var t = f;
        return f = [], t;
      }
    }])), v.hash = c.length ? c.reduce(function (e, t) {
      return t.name || Ua(15), ds(e, t.name);
    }, 5381).toString() : "", v;
  }();
var Ss = function () {
    function e(e, t) {
      var n = this;
      this.inject = function (e, t) {
        void 0 === t && (t = xs);
        var r = n.name + t.hash;
        e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
      }, this.toString = function () {
        return Ua(12, String(n.name));
      }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function (e) {
      return void 0 === e && (e = xs), this.name + e.hash;
    }, e;
  }(),
  As = /([A-Z])/,
  ks = /([A-Z])/g,
  Es = /^ms-/,
  Cs = function Cs(e) {
    return "-" + e.toLowerCase();
  };
function Ts(e) {
  return As.test(e) ? e.replace(ks, Cs).replace(Es, "-ms-") : e;
}
var Ps = function Ps(e) {
  return null == e || !1 === e || "" === e;
};
function Os(e, t, n, r) {
  if (Array.isArray(e)) {
    for (var o, i = [], a = 0, s = e.length; a < s; a += 1) "" !== (o = Os(e[a], t, n, r)) && (Array.isArray(o) ? i.push.apply(i, o) : i.push(o));
    return i;
  }
  if (Ps(e)) return "";
  if (La(e)) return "." + e.styledComponentId;
  if (ja(e)) {
    if ("function" != typeof (c = e) || c.prototype && c.prototype.isReactComponent || !t) return e;
    var u = e(t);
    return "production" !== process.env.NODE_ENV && fi.exports.isElement(u) && console.warn($a(e) + " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."), Os(u, t, n, r);
  }
  var c;
  return e instanceof Ss ? n ? (e.inject(n, r), e.getName(r)) : e : Va(e) ? function e(t, n) {
    var r,
      o,
      i = [];
    for (var a in t) t.hasOwnProperty(a) && !Ps(t[a]) && (Array.isArray(t[a]) && t[a].isCss || ja(t[a]) ? i.push(Ts(a) + ":", t[a], ";") : Va(t[a]) ? i.push.apply(i, e(t[a], a)) : i.push(Ts(a) + ": " + (r = a, (null == (o = t[a]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in Ui ? String(o).trim() : o + "px") + ";")));
    return n ? [n + " {"].concat(i, ["}"]) : i;
  }(e) : e.toString();
}
var Rs = function Rs(e) {
  return Array.isArray(e) && (e.isCss = !0), e;
};
function Is(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  return ja(e) || Va(e) ? Rs(Os(Ma(_a, [e].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : Rs(Os(Ma(e, n)));
}
var Ms = /invalid hook call/i,
  Vs = new Set(),
  _s = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,
  Ns = /(^-|-$)/g;
function js(e) {
  return e.replace(_s, "-").replace(Ns, "");
}
function $s(e) {
  return "string" == typeof e && ("production" === process.env.NODE_ENV || e.charAt(0) === e.charAt(0).toLowerCase());
}
var Ls = function Ls(e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
  },
  Ds = function Ds(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
  };
function zs(e, t, n) {
  var r = e[n];
  Ls(t) && Ls(r) ? Fs(r, t) : e[n] = t;
}
function Fs(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  for (var o = 0, i = n; o < i.length; o++) {
    var a = i[o];
    if (Ls(a)) for (var s in a) Ds(s) && zs(e, a[s], s);
  }
  return e;
}
var Bs = t.createContext();
function Hs(e) {
  var n = r(Bs),
    o = u(function () {
      return function (e, t) {
        if (!e) return Ua(14);
        if (ja(e)) {
          var n = e(t);
          return "production" === process.env.NODE_ENV || null !== n && !Array.isArray(n) && "object" == typeof n ? n : Ua(7);
        }
        return Array.isArray(e) || "object" != typeof e ? Ua(8) : t ? Ia({}, t, {}, e) : e;
      }(e.theme, n);
    }, [e.theme, n]);
  return e.children ? t.createElement(Bs.Provider, {
    value: o
  }, e.children) : null;
}
Bs.Consumer;
var Us = {};
function Ys(e, n, i) {
  var a = La(e),
    s = !$s(e),
    u = n.attrs,
    c = void 0 === u ? _a : u,
    f = n.componentId,
    p = void 0 === f ? function (e, t) {
      var n = "string" != typeof e ? "sc" : js(e);
      Us[n] = (Us[n] || 0) + 1;
      var r = n + "-" + function (e) {
        return fs(ps(e) >>> 0);
      }("5.3.5" + n + Us[n]);
      return t ? t + "-" + r : r;
    }(n.displayName, n.parentComponentId) : f,
    v = n.displayName,
    m = void 0 === v ? function (e) {
      return $s(e) ? "styled." + e : "Styled(" + $a(e) + ")";
    }(e) : v,
    h = n.displayName && n.componentId ? js(n.displayName) + "-" + n.componentId : n.componentId || p,
    y = a && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c,
    g = n.shouldForwardProp;
  a && e.shouldForwardProp && (g = n.shouldForwardProp ? function (t, r, o) {
    return e.shouldForwardProp(t, r, o) && n.shouldForwardProp(t, r, o);
  } : e.shouldForwardProp);
  var b,
    w = new ms(i, h, a ? e.componentStyle : void 0),
    x = w.isStatic && 0 === c.length,
    S = function S(e, t) {
      return function (e, t, n, o) {
        var i = e.attrs,
          a = e.componentStyle,
          s = e.defaultProps,
          u = e.foldedComponentIds,
          c = e.shouldForwardProp,
          f = e.styledComponentId,
          p = e.target;
        "production" !== process.env.NODE_ENV && d(f);
        var v = function (e, t, n) {
            void 0 === e && (e = Na);
            var r = Ia({}, t, {
                theme: e
              }),
              o = {};
            return n.forEach(function (e) {
              var t,
                n,
                i,
                a = e;
              for (t in ja(a) && (a = a(r)), a) r[t] = o[t] = "className" === t ? (n = o[t], i = a[t], n && i ? n + " " + i : n || i) : a[t];
            }), [r, o];
          }(function (e, t, n) {
            return void 0 === n && (n = Na), e.theme !== n.theme && e.theme || t || n.theme;
          }(t, r(Bs), s) || Na, t, i),
          m = v[0],
          h = v[1],
          y = function (e, t, n, o) {
            var i = r(gs) || ws,
              a = r(bs) || xs,
              s = t ? e.generateAndInjectStyles(Na, i, a) : e.generateAndInjectStyles(n, i, a);
            return "production" !== process.env.NODE_ENV && d(s), "production" !== process.env.NODE_ENV && !t && o && o(s), s;
          }(a, o, m, "production" !== process.env.NODE_ENV ? e.warnTooManyClasses : void 0),
          g = n,
          b = h.$as || t.$as || h.as || t.as || p,
          w = $s(b),
          x = h !== t ? Ia({}, t, {}, h) : t,
          S = {};
        for (var A in x) "$" !== A[0] && "as" !== A && ("forwardedAs" === A ? S.as = x[A] : (c ? c(A, qi, b) : !w || qi(A)) && (S[A] = x[A]));
        return t.style && h.style !== t.style && (S.style = Ia({}, t.style, {}, h.style)), S.className = Array.prototype.concat(u, f, y !== f ? y : null, t.className, h.className).filter(Boolean).join(" "), S.ref = g, l(b, S);
      }(b, e, t, x);
    };
  return S.displayName = m, (b = t.forwardRef(S)).attrs = y, b.componentStyle = w, b.displayName = m, b.shouldForwardProp = g, b.foldedComponentIds = a ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : _a, b.styledComponentId = h, b.target = a ? e.target : e, b.withComponent = function (e) {
    var t = n.componentId,
      r = function (e, t) {
        if (null == e) return {};
        var n,
          r,
          o = {},
          i = Object.keys(e);
        for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
        return o;
      }(n, ["componentId"]),
      o = t && t + "-" + ($s(e) ? e : js($a(e)));
    return Ys(e, Ia({}, r, {
      attrs: y,
      componentId: o
    }), i);
  }, Object.defineProperty(b, "defaultProps", {
    get: function get() {
      return this._foldedDefaultProps;
    },
    set: function set(t) {
      this._foldedDefaultProps = a ? Fs({}, e.defaultProps, t) : t;
    }
  }), "production" !== process.env.NODE_ENV && (function (e, t) {
    if ("production" !== process.env.NODE_ENV) {
      var n = "The component " + e + (t ? ' with the id of "' + t + '"' : "") + " has been created dynamically.\nYou may see this warning because you've called styled inside another component.\nTo resolve this only create new StyledComponents outside of any render method and function component.",
        r = console.error;
      try {
        var i = !0;
        console.error = function (e) {
          if (Ms.test(e)) i = !1, Vs.delete(n);else {
            for (var t = arguments.length, o = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++) o[a - 1] = arguments[a];
            r.apply(void 0, [e].concat(o));
          }
        }, o(), i && !Vs.has(n) && (console.warn(n), Vs.add(n));
      } catch (e) {
        Ms.test(e.message) && Vs.delete(n);
      } finally {
        console.error = r;
      }
    }
  }(m, h), b.warnTooManyClasses = function (e, t) {
    var n = {},
      r = !1;
    return function (o) {
      if (!r && (n[o] = !0, Object.keys(n).length >= 200)) {
        var i = t ? ' with the id of "' + t + '"' : "";
        console.warn("Over 200 classes were generated for component " + e + i + ".\nConsider using the attrs method, together with a style object for frequently changed styles.\nExample:\n  const Component = styled.div.attrs(props => ({\n    style: {\n      background: props.background,\n    },\n  }))`width: 100%;`\n\n  <Component />"), r = !0, n = {};
      }
    };
  }(m, h)), b.toString = function () {
    return "." + b.styledComponentId;
  }, s && Ra(b, e, {
    attrs: !0,
    componentStyle: !0,
    displayName: !0,
    foldedComponentIds: !0,
    shouldForwardProp: !0,
    styledComponentId: !0,
    target: !0,
    withComponent: !0
  }), b;
}
var Xs = function Xs(e) {
  return function e(t, n, r) {
    if (void 0 === r && (r = Na), !fi.exports.isValidElementType(n)) return Ua(1, String(n));
    var o = function o() {
      return t(n, r, Is.apply(void 0, arguments));
    };
    return o.withConfig = function (o) {
      return e(t, n, Ia({}, r, {}, o));
    }, o.attrs = function (o) {
      return e(t, n, Ia({}, r, {
        attrs: Array.prototype.concat(r.attrs, o).filter(Boolean)
      }));
    }, o;
  }(Ys, e);
};
["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "textPath", "tspan"].forEach(function (e) {
  Xs[e] = Xs(e);
});
var qs = function qs() {
  return r(Bs);
};
"production" !== process.env.NODE_ENV && "undefined" != typeof navigator && "ReactNative" === navigator.product && console.warn("It looks like you've imported 'styled-components' on React Native.\nPerhaps you're looking to import 'styled-components/native'?\nRead more about this at https://www.styled-components.com/docs/basics#react-native"), "production" !== process.env.NODE_ENV && "test" !== process.env.NODE_ENV && "undefined" != typeof window && (window["__styled-components-init__"] = window["__styled-components-init__"] || 0, 1 === window["__styled-components-init__"] && console.warn("It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.\n\nSee https://s-c.sh/2BAXzed for more info."), window["__styled-components-init__"] += 1);
var Ws,
  Gs,
  Ks,
  Zs = Xs,
  Js = Zs(si.div)(Ws || (Ws = y(["\n  padding: 8px 15px 8px 4px;\n  min-height: 20px;\n  min-width: 0;\n  transition: all 0.2s ease-in-out;\n  &:hover {\n    background: ", ";\n    color: ", ";\n  }\n\n  ", "\n\n  ", "\n"], ["\n  padding: 8px 15px 8px 4px;\n  min-height: 20px;\n  min-width: 0;\n  transition: all 0.2s ease-in-out;\n  &:hover {\n    background: ", ";\n    color: ", ";\n  }\n\n  ", "\n\n  ", "\n"])), function (e) {
    return e.theme._themes[e.currentTheme || "dark"].hoverBg;
  }, function (e) {
    return e.theme._themes[e.currentTheme || "dark"].hoverText;
  }, function (e) {
    var t = e.theme,
      n = e.currentTheme;
    return e.borderTop ? "border-top: 1px solid ".concat(t._themes[n || "dark"].separator, ";") : "";
  }, function (e) {
    return e.selected ? "\n    background-color: ".concat(e.theme._themes[e.currentTheme || "dark"].selectedBg, ";\n    color: ").concat(e.theme._themes[e.currentTheme || "dark"].selectedText, ";\n  ") : "";
  }),
  Qs = Zs(Js)(Gs || (Gs = y(["\n  color: ", ";\n  background-color: ", ";\n"], ["\n  color: ", ";\n  background-color: ", ";\n"])), function (e) {
    var t = e.theme,
      n = e.currentTheme;
    return t._themes[n || "dark"].accentText;
  }, function (e) {
    var t = e.theme,
      n = e.currentTheme;
    return t._themes[n || "dark"].accentBg;
  }),
  eu = Zs(si.div)(Ks || (Ks = y(["\n  padding-left: calc(", ");\n  min-height: 20px;\n  display: flex;\n  align-items: center;\n  min-width: 0;\n"], ["\n  padding-left: calc(", ");\n  min-height: 20px;\n  display: flex;\n  align-items: center;\n  min-width: 0;\n"])), function (e) {
    var t = e.level;
    return "25px * ".concat(t);
  }),
  tu = function tu(t) {
    var n = t.level,
      r = t.children;
    return e.createElement(eu, {
      level: n
    }, r);
  };
tu.defaultProps = {
  level: 0
};
var nu,
  ru,
  ou,
  iu,
  au,
  su,
  uu = Zs.span(nu || (nu = y(["\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow-x: hidden;\n"], ["\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow-x: hidden;\n"]))),
  cu = {
    xlarge: "24px",
    large: "20px",
    default: "16px",
    small: "14px",
    xsmall: "10px"
  },
  lu = Zs(si.div)(ru || (ru = y(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: ", ";\n  height: ", ";\n  text-align: center;\n  padding: 2px;\n  overflow: hidden;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: ", ";\n  height: ", ";\n  text-align: center;\n  padding: 2px;\n  overflow: hidden;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n  }\n"])), function (e) {
    var t = e.size;
    return cu[t];
  }, function (e) {
    var t = e.size;
    return cu[t];
  }),
  fu = Zs(lu)(ou || (ou = y(["\n  svg {\n    height: 100%;\n    width: 100%;\n\n    * {\n      fill: ", ";\n      stroke: ", ";\n    }\n  }\n"], ["\n  svg {\n    height: 100%;\n    width: 100%;\n\n    * {\n      fill: ", ";\n      stroke: ", ";\n    }\n  }\n"])), function (e) {
    var t = e.theme,
      n = e.currentTheme;
    return "".concat(t._themes[n || "dark"].icon);
  }, function (e) {
    var t = e.theme,
      n = e.currentTheme;
    return "".concat(t._themes[n || "dark"].icon);
  }),
  du = si(e.forwardRef(function (t, n) {
    var r = t.size,
      o = void 0 === r ? "default" : r,
      i = t.currentTheme,
      a = void 0 === i ? "dark" : i,
      s = t.defaultIcon,
      u = void 0 !== s && s,
      c = t.children;
    return u ? e.createElement(fu, {
      ref: n,
      currentTheme: a,
      size: o
    }, c) : e.createElement(lu, {
      ref: n,
      size: o
    }, c);
  }), {
    forwardMotionProps: !0
  });
function pu() {
  return pu = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, pu.apply(this, arguments);
}
function vu() {
  return vu = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, vu.apply(this, arguments);
}
function mu() {
  return mu = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, mu.apply(this, arguments);
}
var hu,
  yu,
  gu,
  bu,
  wu,
  xu,
  Su,
  Au = function Au(t) {
    return e.createElement("svg", pu({
      xmlns: "http://www.w3.org/2000/svg",
      width: 22,
      height: 28,
      viewBox: "0 0 22 28"
    }, t), iu || (iu = e.createElement("path", {
      d: "M21.938 21.641c0 2.438-1.859 4.297-4.297 4.297-1.375 0-2.703-.594-3.672-1.563L1.828 12.25C.719 11.125.062 9.594.062 8.016c0-3.313 2.609-5.953 5.922-5.953 1.594 0 3.125.641 4.266 1.766l9.453 9.469a.502.502 0 01.156.344c0 .328-.875 1.203-1.203 1.203a.509.509 0 01-.359-.156L8.828 5.205C8.078 4.471 7.062 4.002 6 4.002c-2.219 0-3.938 1.797-3.938 4 0 1.062.438 2.078 1.188 2.828l12.125 12.141c.594.594 1.422.984 2.266.984 1.328 0 2.312-.984 2.312-2.312 0-.859-.391-1.672-.984-2.266l-9.078-9.078a1.396 1.396 0 00-.938-.375c-.594 0-1.047.438-1.047 1.047 0 .344.156.672.391.922l6.406 6.406a.502.502 0 01.156.344c0 .328-.891 1.219-1.219 1.219a.506.506 0 01-.344-.156L6.89 13.3a3.29 3.29 0 01-.984-2.328A3.028 3.028 0 018.969 7.91c.875 0 1.719.359 2.328.984l9.078 9.078c.984.969 1.563 2.297 1.563 3.672z"
    })));
  },
  ku = function ku(t) {
    return e.createElement("svg", vu({
      xmlns: "http://www.w3.org/2000/svg",
      width: 28,
      height: 28,
      viewBox: "0 0 28 28"
    }, t), au || (au = e.createElement("path", {
      d: "M27.5 14c0 7.453-6.047 13.5-13.5 13.5S.5 21.453.5 14C.5 7.219 5.5 1.609 12 .641v3.563c-4.562.922-8 4.969-8 9.797 0 5.516 4.484 10 10 10s10-4.484 10-10c0-4.828-3.437-8.875-8-9.797V.641C22.5 1.61 27.5 7.219 27.5 14z"
    })));
  },
  Eu = function Eu(t) {
    return e.createElement("svg", mu({
      xmlns: "http://www.w3.org/2000/svg",
      width: 19,
      height: 28,
      viewBox: "0 0 19 28"
    }, t), su || (su = e.createElement("path", {
      d: "M17.297 13.703L5.703 25.297a.99.99 0 01-1.406 0l-2.594-2.594a.99.99 0 010-1.406L10 13 1.703 4.703a.99.99 0 010-1.406L4.297.703a.99.99 0 011.406 0l11.594 11.594a.99.99 0 010 1.406z"
    })));
  },
  Cu = Zs(Js)(hu || (hu = y(["\n  border-left: ", ";\n  transition: all 0.2s linear;\n"], ["\n  border-left: ", ";\n  transition: all 0.2s linear;\n"])), function (e) {
    var t = e.isOpen,
      n = e.theme,
      r = e.currentTheme;
    return t ? "4px solid ".concat(n._themes[r || "dark"].indicator) : "4px solid transparent";
  }),
  Tu = Eu,
  Pu = e.forwardRef(function (t, n) {
    var r = t.data,
      o = t.isOpen,
      i = void 0 !== o && o,
      a = t.isRoot,
      s = void 0 !== a && a,
      u = t.selected,
      c = void 0 !== u && u,
      l = t.level,
      f = void 0 === l ? 0 : l,
      d = t.currentTheme,
      p = void 0 === d ? "dark" : d,
      v = t.noIcons,
      m = void 0 !== v && v,
      h = t.didToggleOpen,
      y = void 0 === h ? function () {} : h,
      g = t.didToggleSelect,
      b = void 0 === g ? function () {} : g,
      w = t.NodeRenderer,
      x = void 0 === w ? null : w,
      S = t.IconRenderer,
      A = void 0 === S ? null : S,
      k = t.borderTop,
      E = void 0 !== k && k;
    if (null === r) return null;
    var C = qs(),
      T = e.useCallback(function (e, t) {
        b(t, e.metaKey || e.ctrlKey), e.metaKey || e.ctrlKey || y(t, !0);
      }, [r, b]),
      P = e.useMemo(function () {
        return A && "function" == typeof A ? e.createElement(du, {
          size: "large",
          currentTheme: p
        }, e.createElement(A, {
          data: r,
          type: "node"
        })) : e.createElement(du, {
          size: C._themes[p || "dark"].textSize,
          currentTheme: p,
          defaultIcon: !0,
          animate: {
            rotate: i ? 90 : 0
          }
        }, e.createElement(Tu, null));
      }, [i]),
      O = "function" == typeof x ? e.createElement("div", {
        title: r.label,
        ref: n,
        "data-node-id": r.id,
        onClick: function onClick(e) {
          return T(e, r.id);
        }
      }, x({
        data: r,
        isOpen: i,
        isRoot: s,
        selected: c,
        level: f
      })) : e.createElement("div", {
        ref: n
      }, e.createElement(Cu, {
        "data-node-id": r.id,
        isOpen: i,
        currentTheme: p,
        selected: c,
        onClick: function onClick(e) {
          return T(e, r.id);
        },
        borderTop: E,
        title: r.label
      }, e.createElement(tu, {
        level: f
      }, !m && e.createElement("span", {
        style: {
          paddingRight: "8px"
        }
      }, P), e.createElement(uu, null, r.label))));
    return O;
  }),
  Ou = si(Pu, {
    forwardMotionProps: !0
  }),
  Ru = Au,
  Iu = e.forwardRef(function (t, n) {
    var r = t.data,
      o = t.selected,
      i = void 0 !== o && o,
      a = t.level,
      s = void 0 === a ? 0 : a,
      u = t.currentTheme,
      c = void 0 === u ? "dark" : u,
      l = t.noIcons,
      f = void 0 !== l && l,
      d = t.didToggleSelect,
      p = void 0 === d ? function () {} : d,
      v = t.LeafRenderer,
      m = void 0 === v ? null : v,
      h = t.IconRenderer,
      y = void 0 === h ? null : h,
      g = t.borderTop,
      b = void 0 !== g && g;
    if (null === r) return null;
    var w = qs(),
      x = e.useCallback(function (e, t) {
        p(t, e.metaKey || e.ctrlKey);
      }, [r, p]),
      S = y && "function" == typeof y ? e.createElement(du, {
        size: "large",
        currentTheme: c
      }, e.createElement(y, {
        data: r,
        type: "leaf"
      })) : e.createElement(du, {
        size: w._themes[c || "dark"].textSize,
        defaultIcon: !0,
        currentTheme: c
      }, e.createElement(Ru, null)),
      A = "function" == typeof m ? e.createElement("div", {
        title: r.label,
        ref: n,
        "data-node-id": r.id,
        onClick: function onClick(e) {
          return x(e, r.id);
        }
      }, m({
        data: r,
        selected: i,
        level: s
      })) : e.createElement("div", {
        ref: n
      }, e.createElement(Js, {
        title: r.label,
        borderTop: b,
        "data-node-id": r.id,
        selected: i,
        currentTheme: c,
        onClick: function onClick(e) {
          return x(e, r.id);
        }
      }, e.createElement(tu, {
        level: s + 1
      }, !f && e.createElement("span", {
        style: {
          paddingRight: "8px"
        }
      }, S), e.createElement(uu, null, r.label))));
    return A;
  }),
  Mu = si(Iu, {
    forwardMotionProps: !0
  }),
  Vu = Zs(si.div)(yu || (yu = y(["\n  min-width: 0;\n"], ["\n  min-width: 0;\n"]))),
  _u = Zs(Vu)(gu || (gu = y([""], [""]))),
  Nu = Zs(Vu)(bu || (bu = y([""], [""]))),
  ju = Zs(Vu)(wu || (wu = y([""], [""]))),
  _$u = function $u(t) {
    var n = t.nodes,
      r = void 0 === n ? [] : n,
      o = t.parent,
      i = void 0 === o ? null : o,
      a = t.level,
      s = void 0 === a ? 0 : a,
      u = t.selectedNodes,
      c = void 0 === u ? [] : u,
      l = t.openNodes,
      f = void 0 === l ? [] : l,
      d = t.didToggleSelect,
      v = void 0 === d ? function () {} : d,
      m = t.didToggleOpen,
      h = void 0 === m ? function () {} : m,
      y = t.currentTheme,
      g = void 0 === y ? "dark" : y,
      b = t.showEmptyItems,
      w = void 0 !== b && b,
      x = t.noIcons,
      S = void 0 !== x && x,
      A = t.NodeRenderer,
      k = void 0 === A ? null : A,
      E = t.LeafRenderer,
      C = void 0 === E ? null : E,
      T = t.IconRenderer,
      P = void 0 === T ? null : T,
      O = t.animations,
      R = void 0 !== O && O,
      I = t.emptyItemsString,
      M = void 0 === I ? null : I,
      V = e.useMemo(function () {
        return function (e, t) {
          return void 0 === t && (t = null), e.filter(function (e) {
            return e.parentId === t;
          });
        }(r || [], i);
      }, [r, i]),
      _ = e.useMemo(function () {
        return function (e, t) {
          return t.map(function (t) {
            return n = e, r = [], _o2 = function o(e) {
              n.forEach(function (t) {
                r.includes(t.id) || t.parentId !== e || t.id === e || (r.push(t.id), _o2(t.id));
              });
            }, _o2(t.id), n.filter(function (e) {
              return r.includes(e.id);
            });
            var n, r, _o2;
          });
        }(r || [], V);
      }, [V]),
      N = R ? {
        initial: {
          opacity: 0,
          y: -25
        },
        animate: {
          opacity: 1,
          y: 0
        },
        exit: {
          opacity: 0
        }
      } : {};
    return e.createElement(Vu, null, e.createElement(_u, null, !!V.length && V.map(function (t, n) {
      return e.createElement(Nu, _p({
        key: n
      }, N, {
        transition: {
          delay: .1 * n
        }
      }), e.createElement(Ou, {
        data: t,
        isOpen: f.includes(t.id),
        selected: c.includes(t.id),
        isRoot: !i,
        level: s,
        currentTheme: g,
        noIcons: S,
        didToggleOpen: h,
        didToggleSelect: v,
        NodeRenderer: k,
        IconRenderer: P,
        borderTop: !i && 0 !== n || !!i
      }), f.includes(t.id) && e.createElement(ju, null, e.createElement(_$u, {
        nodes: _[n],
        parent: t.id,
        level: s + 1,
        selectedNodes: c,
        openNodes: f,
        didToggleSelect: v,
        didToggleOpen: h,
        currentTheme: g,
        showEmptyItems: w,
        noIcons: S,
        NodeRenderer: k,
        LeafRenderer: C,
        IconRenderer: P,
        animations: R,
        emptyItemsString: M
      }), t.items && t.items.map(function (t, r) {
        return e.createElement(Mu, _p({
          key: r
        }, N, {
          transition: {
            delay: .1 * n + .1 * (r + 1)
          },
          data: t,
          level: s,
          currentTheme: g,
          noIcons: S,
          selected: c.includes(t.id),
          LeafRenderer: C,
          IconRenderer: P,
          didToggleSelect: v,
          borderTop: !0
        }));
      }), w && !t.items && e.createElement(Qs, {
        currentTheme: g,
        borderTop: !0,
        selected: !1
      }, e.createElement(tu, {
        level: s + 1
      }, e.createElement("span", null, M || "[No items]")))));
    })));
  },
  Lu = {
    _themes: _p({}, {
      dark: {
        text: "#fafafa",
        bg: "#2d3439",
        indicator: "#64abd4",
        separator: "#555",
        icon: "#64abd4",
        selectedBg: "#3f464e",
        selectedText: "#fafafa",
        hoverBg: "#505a63",
        hoverText: "#fafafa",
        accentBg: "#2d3439",
        accentText: "#999",
        textSize: "default"
      },
      light: {
        text: "#333",
        bg: "#fafafa",
        indicator: "#64abd4",
        separator: "#eee",
        icon: "#64abd4",
        selectedBg: "#f0f0f0",
        selectedText: "#333",
        hoverBg: "#ccc",
        hoverText: "#333",
        accentBg: "#fafafa",
        accentText: "#ccc",
        textSize: "default"
      }
    }),
    _app: _p({}, {
      containerSizes: {
        full: "100%",
        half: "50%",
        narrow: "33%"
      },
      fontSizes: {
        xlarge: "34px",
        large: "20px",
        default: "17px",
        small: "13px",
        xsmall: "10px"
      }
    })
  },
  Du = ku,
  zu = Zs(si.div)(xu || (xu = y(["\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  ", ";\n  padding: 5px;\n  overflow-y: auto;\n  ", ";\n  color: ", ";\n  background-color: ", ";\n\n  & * {\n    user-select: none;\n    cursor: pointer;\n    box-sizing: border-box;\n    font-size: ", ";\n  }\n"], ["\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  ", ";\n  padding: 5px;\n  overflow-y: auto;\n  ", ";\n  color: ", ";\n  background-color: ", ";\n\n  & * {\n    user-select: none;\n    cursor: pointer;\n    box-sizing: border-box;\n    font-size: ", ";\n  }\n"])), function (e) {
    return e.grow ? "flex-grow: 1; height: 100%;" : "";
  }, function (e) {
    var t = e.size,
      n = e.theme;
    return "width: ".concat(t && n._app.containerSizes[t] ? n._app.containerSizes[t] : "unset");
  }, function (e) {
    var t = e.theme,
      n = e.currentTheme;
    return t._themes[n || "dark"].text;
  }, function (e) {
    var t = e.theme,
      n = e.currentTheme;
    return t._themes[n || "dark"].bg;
  }, function (e) {
    var t = e.theme,
      n = e.currentTheme;
    return t._app.fontSizes[t._themes[n || "dark"].textSize];
  }),
  Fu = Zs(si.div)(Su || (Su = y(["\n  align-self: center;\n  margin: auto 0;\n"], ["\n  align-self: center;\n  margin: auto 0;\n"]))),
  Bu = function Bu(e, t, n, r) {
    void 0 === r && (r = !1), e(function (e) {
      var o = e.slice(),
        i = o.findIndex(function (e) {
          return e === n;
        });
      if (!r) {
        var a = [n];
        return -1 != i && (a = []), t(a), a;
      }
      return -1 !== i ? o = o.filter(function (e) {
        return e !== n;
      }) : o.push(n), t(o), o;
    });
  },
  Hu = function Hu(t) {
    var n = t.nodes,
      r = void 0 === n ? [] : n,
      o = t.customTheme,
      i = void 0 === o ? {} : o,
      a = t.theme,
      s = void 0 === a ? "dark" : a,
      u = t.size,
      c = void 0 === u ? "full" : u,
      l = t.grow,
      f = void 0 !== l && l,
      d = t.onSelect,
      v = void 0 === d ? function () {} : d,
      h = t.onOpenClose,
      y = void 0 === h ? function () {} : h,
      g = t.containerStyle,
      b = void 0 === g ? {} : g,
      w = t.showEmptyItems,
      x = void 0 !== w && w,
      S = t.noIcons,
      A = void 0 !== S && S,
      k = t.children,
      E = void 0 === k ? function () {} : k,
      C = t.isLoading,
      T = void 0 !== C && C,
      P = t.NodeRenderer,
      O = void 0 === P ? null : P,
      R = t.LeafRenderer,
      I = void 0 === R ? null : R,
      M = t.IconRenderer,
      V = void 0 === M ? null : M,
      _ = t.animations,
      N = void 0 !== _ && _,
      j = t.noDataString,
      $ = void 0 === j ? null : j,
      L = t.loadingString,
      D = void 0 === L ? null : L,
      z = t.emptyItemsString,
      F = void 0 === z ? null : z,
      B = m(e.useState(r), 2),
      H = B[0],
      U = B[1],
      Y = m(e.useState([]), 2),
      X = Y[0],
      q = Y[1],
      W = m(e.useState([]), 2),
      G = W[0],
      K = W[1],
      Z = e.useRef(null);
    e.useEffect(function () {
      U(r);
    }, [r]);
    var J = e.useMemo(function () {
        return {
          _themes: _p(_p({}, Lu._themes), i),
          _app: _p({}, Lu._app)
        };
      }, [i]),
      Q = Bu.bind(null, q, v),
      ee = Bu.bind(null, K, y);
    e.useEffect(function () {
      var e = function e(_e2) {
        var t;
        (null === (t = null == Z ? void 0 : Z.current) || void 0 === t ? void 0 : t.contains(_e2.target)) || (v([]), q([]));
      };
      if (window) return window.addEventListener("click", e), function () {
        window && window.removeEventListener("click", e);
      };
    }, []);
    var te = V && "function" == typeof V ? e.createElement(du, {
        size: "large"
      }, e.createElement(V, {
        type: "loader"
      })) : e.createElement(du, {
        size: "large",
        defaultIcon: !0,
        initial: {
          rotate: 0
        },
        animate: {
          rotate: 360
        },
        transition: {
          repeat: 1 / 0,
          duration: .8
        }
      }, e.createElement(Du, null)),
      ne = T ? e.createElement(Fu, null, e.createElement("div", {
        style: {
          display: "flex",
          alignItems: "center",
          padding: "20px"
        }
      }, e.createElement("span", {
        style: {
          paddingRight: "4px"
        }
      }, D || "Loading..."), !D && te)) : e.createElement(e.Fragment, null, "function" == typeof E && E({
        toggleNodeSelection: Q,
        toggleSelectAllNodes: function toggleSelectAllNodes() {
          return 0 === X.length ? (q(function () {
            var e = H.map(function (e) {
              return [e.id].concat(e.items ? e.items.map(function (e) {
                return e.id;
              }) : []);
            }).flatMap(function (e) {
              return e;
            });
            return v(e), e;
          }), !0) : (q(function () {
            return v([]), [];
          }), !1);
        },
        toggleOpenCloseNode: ee,
        toggleOpenCloseAllNodes: function toggleOpenCloseAllNodes() {
          return G.length !== H.length ? (K(function () {
            var e = H.map(function (e) {
              return e.id;
            });
            return y(e), e;
          }), !0) : (K(function () {
            return y([]), [];
          }), !1);
        },
        selectedNodeIds: X,
        openNodeIds: G
      }), !r.length && e.createElement(Fu, null, e.createElement("span", null, $ || "No Data...")), !!r.length && e.createElement(_$u, {
        selectedNodes: X,
        openNodes: G,
        didToggleSelect: Q,
        didToggleOpen: ee,
        parent: null,
        nodes: r,
        currentTheme: s || "dark",
        noIcons: A,
        showEmptyItems: x,
        NodeRenderer: O,
        LeafRenderer: I,
        IconRenderer: V,
        animations: N,
        emptyItemsString: F
      }));
    return e.createElement(Hs, {
      theme: J
    }, e.createElement(ui, {
      features: li
    }, e.createElement(zu, {
      ref: Z,
      grow: f,
      currentTheme: s || "dark",
      size: c,
      style: _p({}, b)
    }, ne)));
  };
export { Hu as default };